
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { saveWellnessAssessment, getWellnessAssessments } from "../../service/wellnessAssessment";
// import { Box, IconButton, Dialog, DialogContent } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
// import { drains } from "./AssessmentFlow";
// import { getSmartBiometricSound } from "../../service/home";
// import soundTherapyTracks from "./SmartBiometricTherapy.json";
// import * as Icons from "@mui/icons-material";

// /* ─────────────────────────────────────────────────────────────
//    echoShine design system — ported 1:1 from the HTML prototype
// ───────────────────────────────────────────────────────────── */
// const ECHO_SHINE_CSS = `
// @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700;9..144,800&display=swap');

// .ews-root{
//   --bg:#f5f5fa;--white:#fff;--sf:#fff;--sf2:#eeeff5;--sf3:#e4e5ee;
//   --bd:#dddde6;--bd2:#cbcbd8;
//   --teal:#0d9488;--teal-l:#14b8a6;--teal-bg:rgba(13,148,136,.07);--teal-glow:rgba(13,148,136,.22);
//   --purple:#7c3aed;--purple-l:#8b5cf6;--purple-bg:rgba(124,58,237,.07);--purple-glow:rgba(124,58,237,.18);
//   --amber:#d97706;--amber-bg:rgba(217,119,6,.07);
//   --red:#dc2626;--red-bg:rgba(220,38,38,.06);
//   --green:#16a34a;--green-bg:rgba(22,163,74,.07);
//   --tx:#18162a;--tx2:#5e5c72;--tx3:#908ea3;
//   --r:22px;--rs:14px;
//   font-family:'DM Sans',sans-serif;
//   background:var(--bg);
//   color:var(--tx);
//   width:100%;
//   min-height:100%;
//   position:relative;
// }
// .ews-root *,.ews-root *::before,.ews-root *::after{box-sizing:border-box}
// .ews-bgfx{position:absolute;inset:0;pointer-events:none;z-index:0;
//   background:radial-gradient(ellipse at 15% 5%,rgba(13,148,136,.05) 0%,transparent 50%),
//   radial-gradient(ellipse at 85% 95%,rgba(124,58,237,.04) 0%,transparent 50%);}
// .ews-app{position:relative;z-index:1;width:100%;max-width:420px;margin:0 auto;
//   display:flex;flex-direction:column;gap:14px;padding:20px 16px 48px;}

// .ews-topbar{display:flex;justify-content:space-between;align-items:center;padding:0 2px 2px;position:relative}
// .ews-brand{display:flex;align-items:center;gap:12px}
// .ews-brand-icon{width:42px;height:42px;background:linear-gradient(135deg,var(--teal),var(--purple));
//   border-radius:13px;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;
//   box-shadow:0 4px 16px var(--teal-glow),0 4px 16px var(--purple-glow)}
// .ews-brand-text h1{font-family:'Fraunces',serif;font-size:20px;font-weight:700;line-height:1.2;
//   background:linear-gradient(135deg,var(--teal),var(--purple));-webkit-background-clip:text;
//   -webkit-text-fill-color:transparent;background-clip:text}
// .ews-brand-text p{font-size:11px;color:var(--tx2);letter-spacing:.3px;margin-top:1px}
// .ews-back{background:#F0F5FF !important;width:35px;height:35px;color:#0B2D6B !important;flex-shrink:0}
// .ews-back:hover{background:#E0EBFF !important}

// /* ═══ DESKTOP / LAPTOP RESPONSIVE ═══ */
// @media (min-width: 860px){
//   .ews-app{max-width:920px;padding:36px 32px 64px}
//   .ews-rtitle h2{font-size:30px}
//   .ews-rtitle p{font-size:14px}
//   .ews-grid-2{display:grid;grid-template-columns:1fr 1fr;gap:16px;align-items:stretch}
//   .ews-grid-2 > .ews-card{margin:0}
//   .ews-sc-card{padding:30px 26px}
//   .ews-tlist{display:grid;grid-template-columns:1fr 1fr;gap:14px}
//   .ews-btn-retry{max-width:280px;margin:0 auto}
// }
// @media (min-width: 1200px){
//   .ews-app{max-width:1080px}
//   .ews-tlist{grid-template-columns:1fr 1fr 1fr}
// }

// .ews-card{background:var(--sf);border:1px solid var(--bd);border-radius:var(--r);overflow:hidden;
//   box-shadow:0 2px 12px rgba(0,0,0,.04)}

// .ews-rtitle{text-align:center;padding:10px 0}
// .ews-rtitle h2{font-family:'Fraunces',serif;font-size:24px;font-weight:700;margin-bottom:4px}
// .ews-rtitle p{font-size:13px;color:var(--tx2);margin:0}

// /* combined score */
// .ews-sc-card{display:flex;align-items:center;gap:22px;padding:26px 22px}
// .ews-ring{position:relative;width:105px;height:105px;flex-shrink:0}
// .ews-ring svg{width:100%;height:100%;transform:rotate(-90deg)}
// .ews-ring .ews-rtrk{fill:none;stroke:var(--sf2);stroke-width:7}
// .ews-ring .ews-rfil{fill:none;stroke-width:7;stroke-linecap:round;stroke-dasharray:282.7;
//   transition:stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)}
// .ews-ring .ews-rval{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center}
// .ews-ring .ews-rnum{font-family:'Fraunces',serif;font-size:34px;font-weight:800;line-height:1}
// .ews-ring .ews-rlbl{font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:1px;color:var(--tx3);margin-top:2px}
// .ews-sc-info h3{font-size:15px;font-weight:700;margin:0 0 5px}
// .ews-sc-info p{font-size:12.5px;color:var(--tx2);line-height:1.6;margin:0}

// /* twin mini rings */
// .ews-twin-rings{display:flex;gap:12px;padding:22px}
// .ews-mini-ring-card{flex:1;display:flex;flex-direction:column;align-items:center;gap:8px;
//   padding:20px 12px;border-radius:16px;background:var(--sf2)}
// .ews-mini-ring{position:relative;width:80px;height:80px}
// .ews-mini-ring svg{width:100%;height:100%;transform:rotate(-90deg)}
// .ews-mini-ring .ews-mrtrk{fill:none;stroke:var(--sf3);stroke-width:6}
// .ews-mini-ring .ews-mrfil{fill:none;stroke-width:6;stroke-linecap:round;stroke-dasharray:213.6;
//   transition:stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)}
// .ews-mini-ring .ews-mrval{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center}
// .ews-mini-ring .ews-mrnum{font-family:'Fraunces',serif;font-size:24px;font-weight:800;line-height:1}
// .ews-mrlabel{font-size:10px;font-weight:700;color:var(--tx3);text-transform:uppercase;letter-spacing:.6px;text-align:center}

// /* section headers / lists */
// .ews-sec-h{padding:20px 22px 6px}
// .ews-sec-h h3{font-family:'Fraunces',serif;font-size:16px;font-weight:600;margin:0}
// .ews-sec-h p{font-size:12px;color:var(--tx2);margin:2px 0 0}
// .ews-sec-list{padding:12px 22px 22px;display:flex;flex-direction:column;gap:10px}
// .ews-empty{padding:12px 0;font-size:13px;color:var(--tx3)}

// .ews-tmap-row{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:12px;background:var(--sf2)}
// .ews-tmap-row.high{background:var(--purple-bg);border-left:3px solid var(--purple)}
// .ews-tmap-row.med{background:var(--teal-bg);border-left:3px solid var(--teal)}
// .ews-tz-icon{font-size:20px;width:28px;text-align:center;flex-shrink:0}
// .ews-tz-name{font-size:13px;font-weight:700;color:var(--tx)}
// .ews-tz-what{font-size:11px;color:var(--tx2);line-height:1.4;margin-top:2px}
// .ews-tz-lvl{font-size:10px;font-weight:700;padding:4px 10px;border-radius:8px;text-transform:uppercase;
//   letter-spacing:.4px;white-space:nowrap;flex-shrink:0}
// .ews-tz-lvl.l1{background:rgba(13,148,136,.12);color:var(--teal)}
// .ews-tz-lvl.l2{background:rgba(13,148,136,.2);color:var(--teal)}
// .ews-tz-lvl.l3{background:rgba(124,58,237,.15);color:var(--purple)}

// .ews-drain-row{display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:12px;
//   background:var(--sf2);border-left:3px solid var(--amber)}
// .ews-drain-row .ews-dr-emoji{font-size:20px;width:28px;text-align:center;flex-shrink:0}
// .ews-drain-row .ews-dr-name{font-size:13px;font-weight:700}
// .ews-drain-row .ews-dr-insight{font-size:11px;color:var(--tx2);line-height:1.4;margin-top:2px}

// /* tracks */
// .ews-th{padding:22px 22px 0}
// .ews-th h3{font-family:'Fraunces',serif;font-size:16px;font-weight:600;margin:0 0 4px}
// .ews-th p{font-size:12px;color:var(--tx2);margin:0}
// .ews-tlist{padding:16px 22px 22px;display:flex;flex-direction:column;gap:12px}
// .ews-tc{display:flex;align-items:center;gap:14px;padding:16px;background:var(--sf2);border:1.5px solid var(--bd);
//   border-radius:var(--rs);cursor:pointer;transition:.25s}
// .ews-tc:hover{border-color:var(--teal);background:var(--sf);transform:translateY(-2px);
//   box-shadow:0 8px 24px rgba(13,148,136,.12)}
// .ews-ti{width:48px;height:48px;border-radius:14px;display:flex;align-items:center;justify-content:center;
//   font-size:22px;flex-shrink:0;background:var(--teal-bg)}
// .ews-tb{flex:1;min-width:0}
// .ews-tn{font-size:13.5px;font-weight:700;margin-bottom:2px}
// .ews-td{font-size:11px;color:var(--tx2);line-height:1.4}
// .ews-tp{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,var(--teal-bg),var(--purple-bg));
//   display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:.25s;border:none;cursor:pointer}
// .ews-tc:hover .ews-tp{background:linear-gradient(135deg,var(--teal),var(--purple));box-shadow:0 0 14px var(--teal-glow)}
// .ews-tc:hover .ews-ptri{fill:#fff}

// /* button */
// .ews-btn-retry{background:var(--white);color:var(--teal);border:1.5px solid var(--teal);padding:16px;
//   border-radius:var(--rs);width:100%;font-family:'DM Sans',sans-serif;font-size:14px;font-weight:600;
//   cursor:pointer;transition:.25s;box-shadow:0 2px 8px var(--teal-glow)}
// .ews-btn-retry:hover{background:var(--teal-bg)}

// .ews-note{font-size:10px;color:var(--tx3);text-align:center;line-height:1.6;padding-top:4px}

// .ews-fu{opacity:0;transform:translateY(16px);animation:ews-fu .6s ease forwards}
// @keyframes ews-fu{to{opacity:1;transform:translateY(0)}}
// .ews-d1{animation-delay:.1s}.ews-d2{animation-delay:.2s}.ews-d3{animation-delay:.35s}
// .ews-d4{animation-delay:.5s}.ews-d5{animation-delay:.65s}.ews-d6{animation-delay:.8s}

// /* audio dialog — same visual language */
// .ews-modal-top{padding:28px 24px 4px;text-align:center}
// .ews-modal-icon{width:56px;height:56px;margin:0 auto 14px;background:linear-gradient(135deg,var(--teal),var(--purple));
//   border-radius:18px;display:flex;align-items:center;justify-content:center;font-size:26px;
//   box-shadow:0 8px 24px var(--teal-glow),0 8px 24px var(--purple-glow)}
// .ews-modal-h{font-family:'Fraunces',serif;font-size:19px;font-weight:800;color:var(--tx);margin-bottom:2px}
// .ews-modal-sub{font-size:12.5px;color:var(--tx2)}
// .ews-play-btn{margin-top:16px;padding:14px;border-radius:var(--rs);border:none;width:100%;
//   font-family:'DM Sans',sans-serif;font-size:14px;font-weight:600;color:#fff;cursor:pointer;
//   background:linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6)}
// .ews-progress-time{display:flex;justify-content:space-between;margin-bottom:6px;font-size:11px;color:var(--tx2)}
// .ews-progress-track{height:8px;border-radius:4px;background:var(--sf3);overflow:hidden}
// .ews-progress-fill{height:100%;background:linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6);transition:width .25s linear}
// .ews-complete-btn{margin-top:20px;padding:12px 22px;border-radius:var(--rs);border:none;
//   font-family:'DM Sans',sans-serif;font-size:13.5px;font-weight:600;color:#fff;cursor:pointer;
//   background:linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6);display:block;margin-left:auto;margin-right:auto}
// `;

// const bodyInfo = {
//   Head: { emoji: "🧠", desc: "Tension headaches — cognitive overload, worry, anxiety" },
//   Neck: { emoji: "🦴", desc: "Cervical tension — mental strain, screen fatigue, vigilance" },
//   Chest: { emoji: "❤️", desc: "Chest tightness — anxiety, grief, emotional suppression" },
//   Stomach: { emoji: "🫁", desc: "Gut tension — anxiety, fear, emotional processing (gut-brain axis)" },
//   "Left Shoulder": { emoji: "💪", desc: "Carried burden — emotional weight, responsibility" },
//   "Right Shoulder": { emoji: "💪", desc: "Carried burden — overwork, accumulated stress" },
//   "Left Arm": { emoji: "🦾", desc: "Held tension — control needs, frustration" },
//   "Right Arm": { emoji: "🦾", desc: "Held tension — action suppression, overuse" },
//   "Left Hand": { emoji: "🤲", desc: "Grip tension — holding on, anxiety, control" },
//   "Right Hand": { emoji: "🤲", desc: "Grip tension — perfectionism, repetitive strain" },
//   "Lower Back": { emoji: "🔻", desc: "Foundation strain — financial stress, feeling unsupported" },
//   "Left Leg": { emoji: "🦵", desc: "Restlessness — fight-or-flight activation" },
//   "Right Leg": { emoji: "🦵", desc: "Restlessness — urge to run, grounding loss" },
//   "Left Foot": { emoji: "🦶", desc: "Grounding loss — disconnection, instability" },
//   "Right Foot": { emoji: "🦶", desc: "Grounding loss — restlessness, instability" },
// };

// const PlayTriangle = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24">
//     <polygon className="ews-ptri" points="5,3 19,12 5,21" fill="#0d9488" />
//   </svg>
// );

// const ResultPage = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const [selectedTrack, setSelectedTrack] = useState(null);
//   const [audioUrl, setAudioUrl] = useState("");
//   const [openAudioDialog, setOpenAudioDialog] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [isAudioCompleted, setIsAudioCompleted] = useState(false);
//   const [isPlaying, setIsPlaying] = useState(false);

//   const handleManualPlay = () => {
//     if (!audioRef.current) return;
//     audioRef.current.play().catch((err) => console.log("Manual play failed", err));
//   };

//   const { bodyData = {}, battery = 50, selectedDrains = [], heartRate = null } = state || {};

//   const audioRef = useRef(null);
//   const user = JSON.parse(localStorage.getItem("user"));

//   const formatPart = (part) => {
//     if (part === "lowBack") return "Lower Back";
//     return part.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
//   };

//   const tensionEntries = Object.entries(bodyData).filter(([, v]) => v > 0);
//   const filteredDrains = drains.filter((d) => selectedDrains.includes(d.id));

//   const totalPossibleStress = 15;
//   const currentStress = tensionEntries.reduce((sum, [, level]) => sum + level, 0);
//   const stressRatio = currentStress / totalPossibleStress;
//   const tensionScore = Math.round(Math.max(5, Math.min(95, 100 - stressRatio * 120)));

//   const drainPenalty = filteredDrains.length * 4;
//   const energyScore = Math.max(5, Math.min(95, battery - drainPenalty));
//   const wellnessScore = Math.round(tensionScore * 0.5 + energyScore * 0.5);

//   const getLevel = (level) => {
//     if (level === 1) return { text: "MILD", cls: "l1" };
//     if (level === 2) return { text: "MODERATE", cls: "l2" };
//     return { text: "INTENSE", cls: "l3" };
//   };
//   const getRowClass = (level) => (level === 3 ? "high" : level === 2 ? "med" : "");

//   const getStatusTitle = () => {
//     if (wellnessScore >= 70) return "Well Balanced";
//     if (wellnessScore >= 45) return "Moderate Stress Load";
//     return "Elevated Stress Response";
//   };

//   const getStatusText = () => {
//     if (wellnessScore >= 70)
//       return "Your body and energy are both in good shape. Minimal tension and adequate reserves suggest a well-managed stress response. Maintenance therapy can help sustain this.";
//     if (wellnessScore >= 45)
//       return "Your body is holding tension and/or your energy reserves are under pressure. Targeted sound therapy can address both the physical patterns and mental depletion.";
//     return "Significant body tension combined with depleted energy indicates your system is under considerable strain. Prioritize therapeutic recovery — your body and mind are both asking for care.";
//   };

//   const ringColor = (score) => (score >= 70 ? "var(--teal)" : score >= 45 ? "var(--amber)" : "var(--red)");

//   const getCategory = (wellnessScore) => {
//     if (wellnessScore >= 70) return "low";
//     if (wellnessScore >= 45) return "medium";
//     return "high";
//   };

//   const getRandomSongs = (arr, count = 3) => {
//     if (!arr || arr.length === 0) return [];
//     const shuffled = [...arr];
//     for (let i = shuffled.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//     }
//     return shuffled.slice(0, Math.min(count, shuffled.length));
//   };

//   const category = getCategory(wellnessScore);

//   const songs = useMemo(() => {
//     const selectedSongs = getRandomSongs(soundTherapyTracks[category], 3);
//     if (user?.account_id !== 5) return selectedSongs;
//     return selectedSongs.map((song) => ({ ...song, trackId: `consero-${song.trackId}` }));
//   }, [category, user?.account_id]);

//   const payload = {
//     user_id: user?.id,
//     wellness_score: wellnessScore,
//     tension_score: tensionScore,
//     energy_score: energyScore,
//     battery_input: battery,
//     wellness_status: getStatusTitle(),
//     tension_map: tensionEntries.map(([part, level]) => ({
//       part: formatPart(part),
//       raw_key: part,
//       level: level,
//       label: getLevel(level).text,
//     })),
//     energy_drains: filteredDrains.map((item) => ({
//       id: item.id,
//       label: item.label,
//       insight: item.insight,
//     })),
//     recommended_tracks: songs.map((song) => ({
//       track_id: song.trackId,
//       title: song.title,
//       subtitle: song.subtitle1,
//     })),
//   };

//  useEffect(() => {
//   if (!user?.id) return;

//   const saveAssessment = async () => {
//     try {
//       console.log("Sending Payload", payload);

//       const response = await saveWellnessAssessment(payload);

//       console.log(response);
//     } catch (err) {
//       console.error(err.response?.data || err);
//     }
//   };

//   saveAssessment();
// }, []);
// console.log("user from localStorage:", user);
// console.log("payload being sent:", JSON.stringify(payload, null, 2));
//   const formatTime = (seconds = 0) => {
//     const m = Math.floor(seconds / 60);
//     const s = Math.floor(seconds % 60);
//     return `${m}:${s.toString().padStart(2, "0")}`;
//   };

//   // ring geometry
//   const RING_C = 2 * Math.PI * 45; // combined ring r=45 -> 282.7
//   const MINI_C = 2 * Math.PI * 34; // mini ring r=34 -> 213.6

//   return (
//     <Box className="ews-root">
//       <style>{ECHO_SHINE_CSS}</style>
//       <div className="ews-bgfx" />

//       <div className="ews-app">
//         {/* brand header */}
//         <div className="ews-topbar">
//           <div className="ews-brand">
//             <div className="ews-brand-icon">🌟</div>
//             <div className="ews-brand-text">
//               <h1>echoShine</h1>
//               <p>Student Wellness Assessment</p>
//             </div>
//           </div>
//           <IconButton className="ews-back" onClick={() => navigate("/echo-sounds")}>
//             <ArrowBackIcon fontSize="small" />
//           </IconButton>
//         </div>

//         <div className="ews-rtitle ews-fu">
//           <h2>Your Wellness Profile</h2>
//           <p>Body tension + energy drain analysis</p>
//         </div>

//         {/* combined score + twin rings (side by side on desktop) */}
//         <div className="ews-grid-2">
//         <div className="ews-card ews-fu ews-d1">
//           <div className="ews-sc-card">
//             <div className="ews-ring">
//               <svg viewBox="0 0 100 100">
//                 <defs>
//                   <linearGradient id="ewsRingGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                     <stop offset="0%" stopColor="#14b8a6" />
//                     <stop offset="100%" stopColor="#8b5cf6" />
//                   </linearGradient>
//                 </defs>
//                 <circle className="ews-rtrk" cx="50" cy="50" r="45" />
//                 <circle
//                   className="ews-rfil"
//                   cx="50"
//                   cy="50"
//                   r="45"
//                   stroke="url(#ewsRingGrad)"
//                   style={{ strokeDashoffset: RING_C - (wellnessScore / 100) * RING_C }}
//                 />
//               </svg>
//               <div className="ews-rval">
//                 <span className="ews-rnum" style={{ color: ringColor(wellnessScore) }}>
//                   {wellnessScore}
//                 </span>
//                 <span className="ews-rlbl">Wellness</span>
//               </div>
//             </div>
//             <div className="ews-sc-info">
//               <h3>{getStatusTitle()}</h3>
//               <p>{getStatusText()}</p>
//             </div>
//           </div>
//         </div>

//         {/* twin mini rings */}
//         <div className="ews-card ews-fu ews-d2">
//           <div className="ews-twin-rings">
//             <div className="ews-mini-ring-card">
//               <div className="ews-mini-ring">
//                 <svg viewBox="0 0 76 76">
//                   <defs>
//                     <linearGradient id="ewsBodyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                       <stop offset="0%" stopColor="#14b8a6" />
//                       <stop offset="100%" stopColor="#0d9488" />
//                     </linearGradient>
//                   </defs>
//                   <circle className="ews-mrtrk" cx="38" cy="38" r="34" />
//                   <circle
//                     className="ews-mrfil"
//                     cx="38"
//                     cy="38"
//                     r="34"
//                     stroke="url(#ewsBodyGrad)"
//                     style={{ strokeDashoffset: MINI_C - (tensionScore / 100) * MINI_C }}
//                   />
//                 </svg>
//                 <div className="ews-mrval">
//                   <span className="ews-mrnum" style={{ color: ringColor(tensionScore) }}>
//                     {tensionScore}
//                   </span>
//                 </div>
//               </div>
//               <div className="ews-mrlabel">Body Scan</div>
//             </div>

//             <div className="ews-mini-ring-card">
//               <div className="ews-mini-ring">
//                 <svg viewBox="0 0 76 76">
//                   <defs>
//                     <linearGradient id="ewsEnergyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                       <stop offset="0%" stopColor="#8b5cf6" />
//                       <stop offset="100%" stopColor="#7c3aed" />
//                     </linearGradient>
//                   </defs>
//                   <circle className="ews-mrtrk" cx="38" cy="38" r="34" />
//                   <circle
//                     className="ews-mrfil"
//                     cx="38"
//                     cy="38"
//                     r="34"
//                     stroke="url(#ewsEnergyGrad)"
//                     style={{ strokeDashoffset: MINI_C - (energyScore / 100) * MINI_C }}
//                   />
//                 </svg>
//                 <div className="ews-mrval">
//                   <span className="ews-mrnum" style={{ color: ringColor(energyScore) }}>
//                     {energyScore}
//                   </span>
//                 </div>
//               </div>
//               <div className="ews-mrlabel">Energy Battery</div>
//             </div>
//           </div>
//         </div>
//         </div>

//         {/* tension map + energy drains (side by side on desktop) */}
//         <div className="ews-grid-2">
//         <div className="ews-card ews-fu ews-d3">
//           <div className="ews-sec-h">
//             <h3>Tension Map</h3>
//             <p>Where your body holds stress</p>
//           </div>
//           <div className="ews-sec-list">
//             {tensionEntries.length === 0 ? (
//               <div className="ews-empty">No tension areas reported — your body feels at ease. 🌿</div>
//             ) : (
//               tensionEntries.map(([part, level]) => {
//                 const { text, cls } = getLevel(level);
//                 const formatted = formatPart(part);
//                 return (
//                   <div key={part} className={`ews-tmap-row ${getRowClass(level)}`}>
//                     <span className="ews-tz-icon">{bodyInfo[formatted]?.emoji || "⚡"}</span>
//                     <div style={{ flex: 1 }}>
//                       <div className="ews-tz-name">{formatted}</div>
//                       <div className="ews-tz-what">{bodyInfo[formatted]?.desc}</div>
//                     </div>
//                     <span className={`ews-tz-lvl ${cls}`}>{text}</span>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* energy drains */}
//         {filteredDrains.length > 0 && (
//           <div className="ews-card ews-fu ews-d4">
//             <div className="ews-sec-h">
//               <h3>Energy Drains</h3>
//               <p>What's consuming your reserves</p>
//             </div>
//             <div className="ews-sec-list">
//               {filteredDrains.map((item) => (
//                 <div key={item.id} className="ews-drain-row">
//                   <span className="ews-dr-emoji">{item.icon || "⚡"}</span>
//                   <div style={{ flex: 1 }}>
//                     <div className="ews-dr-name">{item.label}</div>
//                     <div className="ews-dr-insight">{item.insight}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         </div>

//         {/* recommended tracks */}
//         <div className="ews-card ews-fu ews-d5">
//           <div className="ews-th">
//             <h3>Recommended Therapeutic Sounds</h3>
//             <p>Frequency-matched healing audio for your state</p>
//           </div>
//           <div className="ews-tlist">
//             {songs.map((s, i) => {
//               const IconComponent = Icons[s.icon] || Icons.MusicNote;
//               return (
//                 <div key={i} className="ews-tc">
//                   <div className="ews-ti">
//                     <IconComponent sx={{ color: "#0d9488" }} />
//                   </div>
//                   <div className="ews-tb">
//                     <div className="ews-tn">{s.title}</div>
//                     <div className="ews-td">{s.subtitle1}</div>
//                     {s.subtitle2 && <div className="ews-td">{s.subtitle2}</div>}
//                   </div>
//                   <button
//                     type="button"
//                     className="ews-tp"
//                     onClick={async () => {
//                       try {
//                         setLoading(true);
//                         setSelectedTrack(s);
//                         setIsAudioCompleted(false);
//                         setIsPlaying(false);
//                         setCurrentTime(0);
//                         setDuration(0);
//                         const data = await getSmartBiometricSound(s.trackId);
//                         setAudioUrl(data.track_url);
//                         setOpenAudioDialog(true);
//                       } catch (err) {
//                         console.error(err);
//                       } finally {
//                         setLoading(false);
//                       }
//                     }}
//                   >
//                     <PlayTriangle />
//                   </button>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         {/* start over */}
//         <button type="button" className="ews-btn-retry ews-fu ews-d6" onClick={() => navigate("/decode-stress")}>
//           ↻ Start Over
//         </button>

//         <div className="ews-note">echoShine · Wellness Assessment</div>
//       </div>

//       {/* audio dialog — same visual language as the rest of the page */}
//       <Dialog
//         open={openAudioDialog}
//         onClose={() => setOpenAudioDialog(false)}
//         fullWidth
//         maxWidth="xs"
//         PaperProps={{
//           sx: {
//             borderRadius: "22px",
//             fontFamily: "'DM Sans', sans-serif",
//             overflow: "visible",
//           },
//         }}
//       >
//         <DialogContent sx={{ p: 0 }}>
//           <Box className="ews-root" sx={{ borderRadius: "22px" }}>
//             <style>{ECHO_SHINE_CSS}</style>
//             <Box sx={{ position: "relative", px: 3, pb: 3 }}>
//               <IconButton
//                 size="small"
//                 onClick={() => setOpenAudioDialog(false)}
//                 sx={{ position: "absolute", right: 8, top: 8, color: "var(--tx3)" }}
//               >
//                 ✕
//               </IconButton>

//               <div className="ews-modal-top">
//                 <div className="ews-modal-icon">🎵</div>
//                 <div className="ews-modal-h">{selectedTrack?.title}</div>
//                 <div className="ews-modal-sub">echo Therapeutic Session</div>
//               </div>

//               <audio
//                 ref={audioRef}
//                 src={audioUrl}
//                 autoPlay
//                 preload="auto"
//                 style={{ display: "none" }}
//                 onPlay={() => setIsPlaying(true)}
//                 onPause={() => setIsPlaying(false)}
//                 onSeeking={(e) => {
//                   e.target.currentTime = currentTime;
//                 }}
//                 onLoadedMetadata={(e) => setDuration(e.target.duration)}
//                 onTimeUpdate={(e) => setCurrentTime(e.target.currentTime)}
//                 onEnded={() => setIsAudioCompleted(true)}
//               />

//               {!isPlaying && !isAudioCompleted && (
//                 <button type="button" className="ews-play-btn" onClick={handleManualPlay}>
//                   {currentTime > 0 ? "▶ Resume" : "▶ Tap to Play"}
//                 </button>
//               )}

//               <Box sx={{ mt: 2.5 }}>
//                 <div className="ews-progress-time">
//                   <span>{formatTime(currentTime)}</span>
//                   <span>{formatTime(duration)}</span>
//                 </div>
//                 <div className="ews-progress-track">
//                   <div
//                     className="ews-progress-fill"
//                     style={{ width: `${(currentTime / duration) * 100 || 0}%` }}
//                   />
//                 </div>
//               </Box>

//               {isAudioCompleted && (
//                 <button type="button" className="ews-complete-btn" onClick={() => setOpenAudioDialog(false)}>
//                   Complete Session
//                 </button>
//               )}
//             </Box>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };

// export default ResultPage;

//pervious code ui
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { saveWellnessAssessment, getWellnessAssessments } from "../../service/wellnessAssessment";
// import { Box, Typography, Stack, IconButton, Button, Dialog, DialogContent } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
// import { drains } from "./AssessmentFlow";
// import { getSmartBiometricSound } from "../../service/home";
// import soundTherapyTracks from "./SmartBiometricTherapy.json";

// /* ─────────────────────────────────────────────────────────────
//    echoShine design system — ported 1:1 from the HTML prototype
// ───────────────────────────────────────────────────────────── */
// const ECHO_SHINE_CSS = `
// @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700;9..144,800&display=swap');

// .ews-root{
//   --bg:#f5f5fa;--white:#fff;--sf:#fff;--sf2:#eeeff5;--sf3:#e4e5ee;
//   --bd:#dddde6;--bd2:#cbcbd8;
//   --teal:#0d9488;--teal-l:#14b8a6;--teal-bg:rgba(13,148,136,.07);--teal-glow:rgba(13,148,136,.22);
//   --purple:#7c3aed;--purple-l:#8b5cf6;--purple-bg:rgba(124,58,237,.07);--purple-glow:rgba(124,58,237,.18);
//   --amber:#d97706;--amber-bg:rgba(217,119,6,.07);
//   --red:#dc2626;--red-bg:rgba(220,38,38,.06);
//   --green:#16a34a;--green-bg:rgba(22,163,74,.07);
//   --tx:#18162a;--tx2:#5e5c72;--tx3:#908ea3;
//   --r:22px;--rs:14px;
//   font-family:'DM Sans',sans-serif;
//   background:var(--bg);
//   color:var(--tx);
//   width:100%;
//   min-height:100%;
//   position:relative;
// }
// .ews-root *,.ews-root *::before,.ews-root *::after{box-sizing:border-box}
// .ews-bgfx{position:absolute;inset:0;pointer-events:none;z-index:0;
//   background:radial-gradient(ellipse at 15% 5%,rgba(13,148,136,.05) 0%,transparent 50%),
//   radial-gradient(ellipse at 85% 95%,rgba(124,58,237,.04) 0%,transparent 50%);}
// .ews-app{position:relative;z-index:1;width:100%;max-width:420px;margin:0 auto;
//   display:flex;flex-direction:column;gap:14px;padding:20px 16px 48px;}

// .ews-topbar{display:flex;justify-content:space-between;align-items:center;padding:0 2px 2px;position:relative}
// .ews-brand{display:flex;align-items:center;gap:12px}
// .ews-brand-icon{width:42px;height:42px;background:linear-gradient(135deg,var(--teal),var(--purple));
//   border-radius:13px;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;
//   box-shadow:0 4px 16px var(--teal-glow),0 4px 16px var(--purple-glow)}
// .ews-brand-text h1{font-family:'Fraunces',serif;font-size:20px;font-weight:700;line-height:1.2;
//   background:linear-gradient(135deg,var(--teal),var(--purple));-webkit-background-clip:text;
//   -webkit-text-fill-color:transparent;background-clip:text;margin:0}
// .ews-brand-text p{font-size:11px;color:var(--tx2);letter-spacing:.3px;margin-top:1px;margin-bottom:0}
// .ews-back{background:#F0F5FF !important;width:35px;height:35px;color:#0B2D6B !important;flex-shrink:0}
// .ews-back:hover{background:#E0EBFF !important}

// /* ═══ DESKTOP / LAPTOP RESPONSIVE ═══ */
// @media (min-width: 860px){
//   .ews-app{max-width:920px;padding:36px 32px 64px}
//   .ews-rtitle h2{font-size:30px}
//   .ews-rtitle p{font-size:14px}
//   .ews-grid-2{display:grid;grid-template-columns:1fr 1fr;gap:16px;align-items:stretch}
//   .ews-grid-2 > .ews-card{margin:0}
//   .ews-sc-card{padding:30px 26px}
//   .ews-tlist{display:grid;grid-template-columns:1fr 1fr;gap:14px}
//   .ews-btn-retry{max-width:280px;margin:0 auto}
// }
// @media (min-width: 1200px){
//   .ews-app{max-width:1080px}
//   .ews-tlist{grid-template-columns:1fr 1fr 1fr}
// }

// .ews-card{background:var(--sf);border:1px solid var(--bd);border-radius:var(--r);overflow:hidden;
//   box-shadow:0 2px 12px rgba(0,0,0,.04)}

// .ews-rtitle{text-align:center;padding:10px 0}
// .ews-rtitle h2{font-family:'Fraunces',serif;font-size:24px;font-weight:700;margin-bottom:4px;margin-top:0}
// .ews-rtitle p{font-size:13px;color:var(--tx2);margin:0}

// /* combined score */
// .ews-sc-card{display:flex;align-items:center;gap:22px;padding:26px 22px}
// .ews-ring{position:relative;width:105px;height:105px;flex-shrink:0}
// .ews-ring svg{width:100%;height:100%;transform:rotate(-90deg)}
// .ews-ring .ews-rtrk{fill:none;stroke:var(--sf2);stroke-width:7}
// .ews-ring .ews-rfil{fill:none;stroke-width:7;stroke-linecap:round;stroke-dasharray:282.7;
//   transition:stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)}
// .ews-ring .ews-rval{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center}
// .ews-ring .ews-rnum{font-family:'Fraunces',serif;font-size:34px;font-weight:800;line-height:1;display:block}
// .ews-ring .ews-rlbl{font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:1px;color:var(--tx3);margin-top:2px;display:block}
// .ews-sc-info h3{font-size:15px;font-weight:700;margin:0 0 5px}
// .ews-sc-info p{font-size:12.5px;color:var(--tx2);line-height:1.6;margin:0}

// /* twin mini rings */
// .ews-twin-rings{display:flex;gap:12px;padding:22px}
// .ews-mini-ring-card{flex:1;display:flex;flex-direction:column;align-items:center;gap:8px;
//   padding:20px 12px;border-radius:16px;background:var(--sf2)}
// .ews-mini-ring{position:relative;width:80px;height:80px}
// .ews-mini-ring svg{width:100%;height:100%;transform:rotate(-90deg)}
// .ews-mini-ring .ews-mrtrk{fill:none;stroke:var(--sf3);stroke-width:6}
// .ews-mini-ring .ews-mrfil{fill:none;stroke-width:6;stroke-linecap:round;stroke-dasharray:213.6;
//   transition:stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)}
// .ews-mini-ring .ews-mrval{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center}
// .ews-mini-ring .ews-mrnum{font-family:'Fraunces',serif;font-size:24px;font-weight:800;line-height:1;display:block}
// .ews-mrlabel{font-size:10px;font-weight:700;color:var(--tx3);text-transform:uppercase;letter-spacing:.6px;text-align:center}

// /* section headers / lists */
// .ews-sec-h{padding:20px 22px 6px}
// .ews-sec-h h3{font-family:'Fraunces',serif;font-size:16px;font-weight:600;margin:0}
// .ews-sec-h p{font-size:12px;color:var(--tx2);margin:2px 0 0}
// .ews-sec-list{padding:12px 22px 22px;display:flex;flex-direction:column;gap:10px}
// .ews-empty{padding:12px 0;font-size:13px;color:var(--tx3)}

// .ews-tmap-row{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:12px;background:var(--sf2)}
// .ews-tmap-row.high{background:var(--purple-bg);border-left:3px solid var(--purple)}
// .ews-tmap-row.med{background:var(--teal-bg);border-left:3px solid var(--teal)}
// .ews-tz-icon{font-size:20px;width:28px;text-align:center;flex-shrink:0}
// .ews-tz-name{font-size:13px;font-weight:700;color:var(--tx)}
// .ews-tz-what{font-size:11px;color:var(--tx2);line-height:1.4;margin-top:2px}
// .ews-tz-lvl{font-size:10px;font-weight:700;padding:4px 10px;border-radius:8px;text-transform:uppercase;
//   letter-spacing:.4px;white-space:nowrap;flex-shrink:0}
// .ews-tz-lvl.l1{background:rgba(13,148,136,.12);color:var(--teal)}
// .ews-tz-lvl.l2{background:rgba(13,148,136,.2);color:var(--teal)}
// .ews-tz-lvl.l3{background:rgba(124,58,237,.15);color:var(--purple)}

// .ews-drain-row{display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:12px;
//   background:var(--sf2);border-left:3px solid var(--amber)}
// .ews-drain-row .ews-dr-emoji{font-size:20px;width:28px;text-align:center;flex-shrink:0}
// .ews-drain-row .ews-dr-name{font-size:13px;font-weight:700}
// .ews-drain-row .ews-dr-insight{font-size:11px;color:var(--tx2);line-height:1.4;margin-top:2px}

// /* tracks */
// .ews-th{padding:22px 22px 0}
// .ews-th h3{font-family:'Fraunces',serif;font-size:16px;font-weight:600;margin:0 0 4px}
// .ews-th p{font-size:12px;color:var(--tx2);margin:0}
// .ews-tlist{padding:16px 22px 22px;display:flex;flex-direction:column;gap:12px}
// .ews-tc{display:flex;align-items:center;gap:14px;padding:16px;background:var(--sf2);border:1.5px solid var(--bd);
//   border-radius:var(--rs);cursor:pointer;transition:.25s}
// .ews-tc:hover{border-color:var(--teal);background:var(--sf);transform:translateY(-2px);
//   box-shadow:0 8px 24px rgba(13,148,136,.12)}
// .ews-ti{width:52px;height:52px;border-radius:14px;display:flex;align-items:center;justify-content:center;
//   font-size:24px;flex-shrink:0}
// .ews-tb{flex:1;min-width:0}
// .ews-tn{font-size:14px;font-weight:700;margin-bottom:3px;color:var(--tx)}
// .ews-td{font-size:11.5px;color:var(--tx2);line-height:1.4;margin-bottom:8px}
// .ews-tags{display:flex;gap:6px;flex-wrap:wrap}
// .ews-tag{font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px;
//   background:var(--teal-bg);color:var(--teal);letter-spacing:.3px;white-space:nowrap;display:inline-block}
// .ews-tp{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,var(--teal-bg),var(--purple-bg));
//   display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:.25s;border:none;cursor:pointer}
// .ews-tc:hover .ews-tp{background:linear-gradient(135deg,var(--teal),var(--purple));box-shadow:0 0 14px var(--teal-glow)}
// .ews-tc:hover .ews-ptri{fill:#fff}

// /* button */
// .ews-btn-retry{background:var(--white);color:var(--teal);border:1.5px solid var(--teal);padding:16px;
//   border-radius:var(--rs);width:100%;font-family:'DM Sans',sans-serif;font-size:14px;font-weight:600;
//   cursor:pointer;transition:.25s;box-shadow:0 2px 8px var(--teal-glow);text-transform:none}
// .ews-btn-retry:hover{background:var(--teal-bg)}

// .ews-note{font-size:10px;color:var(--tx3);text-align:center;line-height:1.6;padding-top:4px}

// .ews-fu{opacity:0;transform:translateY(16px);animation:ews-fu .6s ease forwards}
// @keyframes ews-fu{to{opacity:1;transform:translateY(0)}}
// .ews-d1{animation-delay:.1s}.ews-d2{animation-delay:.2s}.ews-d3{animation-delay:.35s}
// .ews-d4{animation-delay:.5s}.ews-d5{animation-delay:.65s}.ews-d6{animation-delay:.8s}

// /* audio dialog — same visual language */
// .ews-modal-top{padding:28px 24px 4px;text-align:center}
// .ews-modal-icon{width:56px;height:56px;margin:0 auto 14px;background:linear-gradient(135deg,var(--teal),var(--purple));
//   border-radius:18px;display:flex;align-items:center;justify-content:center;font-size:26px;
//   box-shadow:0 8px 24px var(--teal-glow),0 8px 24px var(--purple-glow)}
// .ews-modal-h{font-family:'Fraunces',serif;font-size:19px;font-weight:800;color:var(--tx);margin-bottom:2px}
// .ews-modal-sub{font-size:12.5px;color:var(--tx2)}
// .ews-play-btn{margin-top:16px;padding:14px;border-radius:var(--rs);border:none;width:100%;
//   font-family:'DM Sans',sans-serif;font-size:14px;font-weight:600;color:#fff;cursor:pointer;
//   background:linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6);text-transform:none}
// .ews-progress-time{display:flex;justify-content:space-between;margin-bottom:6px;font-size:11px;color:var(--tx2)}
// .ews-progress-track{height:8px;border-radius:4px;background:var(--sf3);overflow:hidden}
// .ews-progress-fill{height:100%;background:linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6);transition:width .25s linear}
// .ews-complete-btn{margin-top:20px;padding:12px 22px;border-radius:var(--rs);border:none;
//   font-family:'DM Sans',sans-serif;font-size:13.5px;font-weight:600;color:#fff;cursor:pointer;
//   background:linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6);display:block;margin-left:auto;margin-right:auto;text-transform:none}
// `;

// const bodyInfo = {
//   Head: { emoji: "🧠", desc: "Tension headaches — cognitive overload, worry, anxiety" },
//   Neck: { emoji: "🦴", desc: "Cervical tension — mental strain, screen fatigue, vigilance" },
//   Chest: { emoji: "❤️", desc: "Chest tightness — anxiety, grief, emotional suppression" },
//   Stomach: { emoji: "🫁", desc: "Gut tension — anxiety, fear, emotional processing (gut-brain axis)" },
//   "Left Shoulder": { emoji: "💪", desc: "Carried burden — emotional weight, responsibility" },
//   "Right Shoulder": { emoji: "💪", desc: "Carried burden — overwork, accumulated stress" },
//   "Left Arm": { emoji: "🦾", desc: "Held tension — control needs, frustration" },
//   "Right Arm": { emoji: "🦾", desc: "Held tension — action suppression, overuse" },
//   "Left Hand": { emoji: "🤲", desc: "Grip tension — holding on, anxiety, control" },
//   "Right Hand": { emoji: "🤲", desc: "Grip tension — perfectionism, repetitive strain" },
//   "Lower Back": { emoji: "🔻", desc: "Foundation strain — financial stress, feeling unsupported" },
//   "Left Leg": { emoji: "🦵", desc: "Restlessness — fight-or-flight activation" },
//   "Right Leg": { emoji: "🦵", desc: "Restlessness — urge to run, grounding loss" },
//   "Left Foot": { emoji: "🦶", desc: "Grounding loss — disconnection, instability" },
//   "Right Foot": { emoji: "🦶", desc: "Grounding loss — restlessness, instability" },
// };

// const PROTOTYPE_TRACKS_BY_CATEGORY = {
//   low: [
//     { trackId: "sound-therapy-low-en-1.mp3", title: "Deep Calm — 174 Hz", subtitle1: "Grounding frequency for safety and deep relaxation", subtitle2: "Balance", frequency: "174 Hz", duration: "12 min", icon: "calm", emoji: "🌊" },
//     { trackId: "sound-therapy-low-en-2.mp3", title: "Tranquil Mind — 396 Hz", subtitle1: "Liberation frequency to dissolve held tension", subtitle2: "Calm Focus", frequency: "396 Hz", duration: "15 min", icon: "calm", emoji: "🍃" },
//     { trackId: "sound-therapy-low-en-3.mp3", title: "Inner Peace — 528 Hz", subtitle1: "Transformation frequency for cellular-level restoration", subtitle2: "Light Relaxation", frequency: "528 Hz", duration: "18 min", icon: "calm", emoji: "✨" },
//     { trackId: "sound-therapy-low-en-4.mp3", title: "Serenity Flow — 285 Hz", subtitle1: "Cellular repair and continued relaxation", subtitle2: "Emotional Ease", frequency: "285 Hz", duration: "14 min", icon: "calm", emoji: "💧" },
//   ],
//   medium: [
//     { trackId: "sound-therapy-medium-en-16.mp3", title: "Tension Release — 396 Hz", subtitle1: "Target stress-held tension in your body and mind", subtitle2: "Stress Reset", frequency: "396 Hz", duration: "20 min", icon: "heal", emoji: "🌸" },
//     { trackId: "sound-therapy-medium-en-17.mp3", title: "Somatic Reset — 417 Hz", subtitle1: "Break stress patterns and restore energy flow", subtitle2: "Calm Recovery", frequency: "417 Hz", duration: "18 min", icon: "heal", emoji: "🔄" },
//     { trackId: "sound-therapy-medium-en-18.mp3", title: "Heart Opener — 639 Hz", subtitle1: "Reconnect emotionally when drained and isolated", subtitle2: "Emotional Balance", frequency: "639 Hz", duration: "15 min", icon: "heal", emoji: "💚" },
//     { trackId: "sound-therapy-medium-en-19.mp3", title: "Ground & Center — 174 Hz", subtitle1: "Lowest Solfeggio to anchor a depleted system", subtitle2: "Focused Calm", frequency: "174 Hz", duration: "22 min", icon: "heal", emoji: "🫧" },
//   ],
//   high: [
//     { trackId: "sound-therapy-high-en-31.mp3", title: "Morning Awakening — 741 Hz", subtitle1: "Cleansing frequency to revitalize depleted energy", subtitle2: "Energy Reset", frequency: "741 Hz", duration: "10 min", icon: "energy", emoji: "☀️" },
//     { trackId: "sound-therapy-high-en-32.mp3", title: "Focus Boost — 852 Hz", subtitle1: "Sharpen scattered energy into focused clarity", subtitle2: "Mental Clarity", frequency: "852 Hz", duration: "12 min", icon: "focus", emoji: "🎯" },
//     { trackId: "sound-therapy-high-en-33.mp3", title: "Vitality Surge — 963 Hz", subtitle1: "Full activation for deep depletion recovery", subtitle2: "Recovery", frequency: "963 Hz", duration: "14 min", icon: "energy", emoji: "⚡" },
//     { trackId: "sound-therapy-high-en-34.mp3", title: "Creative Flow — 528 Hz", subtitle1: "Reignite creative and motivational energy", subtitle2: "Inspiration", frequency: "528 Hz", duration: "16 min", icon: "energy", emoji: "🎨" },
//   ],
// };

// // Fallback icon/color palette used when a track doesn't specify its own emoji/iconBg
// // Exact emoji per track, taken from the HTML prototype's TRK library.
// // Keyed by title so it works regardless of which pool the track came from.
// const TRACK_EMOJI_MAP = {
//   "Deep Calm — 174 Hz": "🌊",
//   "Tranquil Mind — 396 Hz": "🍃",
//   "Inner Peace — 528 Hz": "✨",
//   "Serenity Flow — 285 Hz": "💧",
//   "Tension Release — 396 Hz": "🌸",
//   "Somatic Reset — 417 Hz": "🔄",
//   "Heart Opener — 639 Hz": "💚",
//   "Ground & Center — 174 Hz": "🫧",
//   "Morning Awakening — 741 Hz": "☀️",
//   "Focus Boost — 852 Hz": "🎯",
//   "Vitality Surge — 963 Hz": "⚡",
//   "Creative Flow — 528 Hz": "🎨",
//   "Sleep Cradle — 174 Hz": "🌙",
//   "Dream Weave — 285 Hz": "💤",
//   "Night Calm — 396 Hz": "🌌",
//   "Deep Rest — 432 Hz": "🛌",
// };

// // Background tint per icon category — matches .ti.calm / .ti.heal / .ti.energy /
// // .ti.sleep / .ti.focus in the HTML prototype's CSS.
// const TRACK_ICON_BG_MAP = {
//   calm: "rgba(13,148,136,.07)",
//   heal: "rgba(220,38,38,.06)",
//   energy: "rgba(217,119,6,.07)",
//   sleep: "rgba(124,58,237,.07)",
//   focus: "rgba(37,99,235,.07)",
// };

// const TRACK_ICON_CATEGORY_MAP = {
//   musicnote: "calm",
//   centerfocusstrong: "focus",
//   volumedown: "calm",
//   restore: "calm",
//   landscape: "heal",
//   selfimprovement: "focus",
//   terrain: "calm",
//   psychology: "heal",
//   air: "calm",
//   waves: "sleep",
//   pausecircle: "sleep",
//   scale: "focus",
//   adjust: "focus",
//   favoriteborder: "heal",
//   sync: "energy",
//   visibility: "heal",
//   shield: "calm",
// };

// const TRACK_ICON_EMOJI_MAP = {
//   musicnote: "🎵",
//   centerfocusstrong: "🧘",
//   volumedown: "🔈",
//   restore: "🌿",
//   landscape: "🌄",
//   selfimprovement: "✨",
//   terrain: "🪨",
//   psychology: "🧠",
//   air: "💨",
//   waves: "🌊",
//   pausecircle: "⏸️",
//   scale: "⚖️",
//   adjust: "🎚️",
//   favoriteborder: "💛",
//   sync: "🔄",
//   visibility: "👁️",
//   shield: "🛡️",
//   default: "🎵",
// };

// const normalizeTrackTitle = (value = "") =>
//   String(value)
//     .trim()
//     .toLowerCase()
//     .replace(/[\s—-]+/g, " ")
//     .replace(/\s+\d+\s*(hz|hertz)?$/i, "")
//     .replace(/\s+/g, " ");

// const getTrackEmoji = (song = {}) => {
//   if (song?.emoji) return song.emoji;

//   const directMatch = song?.title && TRACK_EMOJI_MAP[song.title];
//   if (directMatch) return directMatch;

//   const normalizedTitle = normalizeTrackTitle(song?.title);
//   const matchedTitle = Object.entries(TRACK_EMOJI_MAP).find(([title]) => normalizeTrackTitle(title) === normalizedTitle);
//   if (matchedTitle) return matchedTitle[1];

//   const iconKey = String(song?.icon || "").toLowerCase();
//   return TRACK_ICON_EMOJI_MAP[iconKey] || TRACK_ICON_EMOJI_MAP.default;
// };

// const getTrackIconBg = (song = {}) => {
//   if (song?.iconBg) return song.iconBg;

//   const iconKey = String(song?.icon || "").toLowerCase();
//   const category = TRACK_ICON_CATEGORY_MAP[iconKey];
//   return TRACK_ICON_BG_MAP[category] || "rgba(13,148,136,.07)";
// };

// const formatTagValue = (value, unitSuffix) => {
//   if (value === undefined || value === null || value === "") return null;
//   if (typeof value === "number") return `${value} ${unitSuffix}`;
//   return String(value);
// };

// const PlayTriangle = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24">
//     <polygon className="ews-ptri" points="5,3 19,12 5,21" fill="#0d9488" />
//   </svg>
// );

// const ResultPage = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const [selectedTrack, setSelectedTrack] = useState(null);
//   const [audioUrl, setAudioUrl] = useState("");
//   const [openAudioDialog, setOpenAudioDialog] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [isAudioCompleted, setIsAudioCompleted] = useState(false);
//   const [isPlaying, setIsPlaying] = useState(false);

//   const handleManualPlay = () => {
//     if (!audioRef.current) return;
//     audioRef.current.play().catch((err) => console.log("Manual play failed", err));
//   };

//   const { bodyData = {}, battery = 50, selectedDrains = [], heartRate = null } = state || {};

//   const audioRef = useRef(null);
//   const user = JSON.parse(localStorage.getItem("user"));

//   const formatPart = (part) => {
//     if (part === "lowBack") return "Lower Back";
//     return part.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
//   };

//   const tensionEntries = Object.entries(bodyData).filter(([, v]) => v > 0);
//   const filteredDrains = drains.filter((d) => selectedDrains.includes(d.id));

//   const totalPossibleStress = 15;
//   const currentStress = tensionEntries.reduce((sum, [, level]) => sum + level, 0);
//   const stressRatio = currentStress / totalPossibleStress;
//   const tensionScore = Math.round(Math.max(5, Math.min(95, 100 - stressRatio * 120)));

//   const drainPenalty = filteredDrains.length * 4;
//   const energyScore = Math.max(5, Math.min(95, battery - drainPenalty));
//   const wellnessScore = Math.round(tensionScore * 0.5 + energyScore * 0.5);

//   const getLevel = (level) => {
//     if (level === 1) return { text: "MILD", cls: "l1" };
//     if (level === 2) return { text: "MODERATE", cls: "l2" };
//     return { text: "INTENSE", cls: "l3" };
//   };
//   const getRowClass = (level) => (level === 3 ? "high" : level === 2 ? "med" : "");

//   const getStatusTitle = () => {
//     if (wellnessScore >= 70) return "Well Balanced";
//     if (wellnessScore >= 45) return "Moderate Stress Load";
//     return "Elevated Stress Response";
//   };

//   const getStatusText = () => {
//     if (wellnessScore >= 70)
//       return "Your body and energy are both in good shape. Minimal tension and adequate reserves suggest a well-managed stress response. Maintenance therapy can help sustain this.";
//     if (wellnessScore >= 45)
//       return "Your body is holding tension and/or your energy reserves are under pressure. Targeted sound therapy can address both the physical patterns and mental depletion.";
//     return "Significant body tension combined with depleted energy indicates your system is under considerable strain. Prioritize therapeutic recovery — your body and mind are both asking for care.";
//   };

//   const ringColor = (score) => (score >= 70 ? "var(--teal)" : score >= 45 ? "var(--amber)" : "var(--red)");

//   const getCategory = (wellnessScore) => {
//     if (wellnessScore >= 70) return "low";
//     if (wellnessScore >= 45) return "medium";
//     return "high";
//   };

//   const getRandomSongs = (arr, count = 3) => {
//     if (!arr || arr.length === 0) return [];
//     const shuffled = [...arr];
//     for (let i = shuffled.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//     }
//     return shuffled.slice(0, Math.min(count, shuffled.length));
//   };

//   const category = getCategory(wellnessScore);

//   const songs = useMemo(() => {
//     const pool = PROTOTYPE_TRACKS_BY_CATEGORY[category] || PROTOTYPE_TRACKS_BY_CATEGORY.low;
//     const selectedPrototypeSongs = getRandomSongs(pool, 3);
//     const selectedBaseSongs = getRandomSongs(soundTherapyTracks[category] || [], 3);

//     const mappedSongs = selectedPrototypeSongs.map((song, index) => {
//       const baseSong = selectedBaseSongs[index] || {};
//       return {
//         ...baseSong,
//         ...song,
//         trackId: baseSong.trackId || song.trackId,
//         subtitle1: song.subtitle1,
//         subtitle2: song.subtitle2,
//         frequency: song.frequency,
//         duration: song.duration,
//         icon: song.icon,
//         emoji: song.emoji,
//       };
//     });

//     if (user?.account_id !== 5) return mappedSongs;
//     return mappedSongs.map((song) => ({ ...song, trackId: `consero-${song.trackId}` }));
//   }, [category, user?.account_id]);

//   const payload = {
//     user_id: user?.id,
//     wellness_score: wellnessScore,
//     tension_score: tensionScore,
//     energy_score: energyScore,
//     battery_input: battery,
//     wellness_status: getStatusTitle(),
//     tension_map: tensionEntries.map(([part, level]) => ({
//       part: formatPart(part),
//       raw_key: part,
//       level: level,
//       label: getLevel(level).text,
//     })),
//     energy_drains: filteredDrains.map((item) => ({
//       id: item.id,
//       label: item.label,
//       insight: item.insight,
//     })),
//     recommended_tracks: songs.map((song) => ({
//       track_id: song.trackId,
//       title: song.title,
//       subtitle: song.subtitle1,
//     })),
//   };

//   useEffect(() => {
//     if (!user?.id) return;

//     const saveAssessment = async () => {
//       try {
//         console.log("Sending Payload", payload);
//         const response = await saveWellnessAssessment(payload);
//         console.log(response);
//       } catch (err) {
//         console.error(err.response?.data || err);
//       }
//     };

//     saveAssessment();
//   }, []);

//   const formatTime = (seconds = 0) => {
//     const m = Math.floor(seconds / 60);
//     const s = Math.floor(seconds % 60);
//     return `${m}:${s.toString().padStart(2, "0")}`;
//   };
//   const handleTrackClick = async (track) => {
//     try {
//       setLoading(true);
//       setSelectedTrack(track);
//       setIsAudioCompleted(false);
//       setIsPlaying(false);
//       setCurrentTime(0);
//       setDuration(0);

//       const data = await getSmartBiometricSound(track.trackId);

//       setAudioUrl(data.track_url);
//       setOpenAudioDialog(true);
//     } catch (err) {
//       console.error("Failed to load therapeutic sound:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ring geometry
//   const RING_C = 2 * Math.PI * 45; // combined ring r=45 -> 282.7
//   const MINI_C = 2 * Math.PI * 34; // mini ring r=34 -> 213.6

//   return (
//     <Box className="ews-root">
//       <style>{ECHO_SHINE_CSS}</style>
//       <Box className="ews-bgfx" />

//       <Box className="ews-app">
//         {/* brand header */}
//         <Box className="ews-topbar">
//           <Box className="ews-brand">
//             <Box className="ews-brand-icon">🌟</Box>
//             <Box className="ews-brand-text">
//               <Typography component="h1">echoShine</Typography>
//               <Typography component="p">Student Wellness Assessment</Typography>
//             </Box>
//           </Box>
//           <IconButton className="ews-back" onClick={() => navigate("/echo-sounds")}>
//             <ArrowBackIcon fontSize="small" />
//           </IconButton>
//         </Box>

//         <Box className="ews-rtitle ews-fu">
//           <Typography component="h2">Your Wellness Profile</Typography>
//           <Typography component="p">Body tension + energy drain analysis</Typography>
//         </Box>

//         {/* combined score + twin rings (side by side on desktop) */}
//         <Box className="ews-grid-2">
//           <Box className="ews-card ews-fu ews-d1">
//             <Box className="ews-sc-card">
//               <Box className="ews-ring">
//                 <svg viewBox="0 0 100 100">
//                   <defs>
//                     <linearGradient id="ewsRingGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                       <stop offset="0%" stopColor="#14b8a6" />
//                       <stop offset="100%" stopColor="#8b5cf6" />
//                     </linearGradient>
//                   </defs>
//                   <circle className="ews-rtrk" cx="50" cy="50" r="45" />
//                   <circle
//                     className="ews-rfil"
//                     cx="50"
//                     cy="50"
//                     r="45"
//                     stroke="url(#ewsRingGrad)"
//                     style={{ strokeDashoffset: RING_C - (wellnessScore / 100) * RING_C }}
//                   />
//                 </svg>
//                 <Box className="ews-rval">
//                   <Typography component="span" className="ews-rnum" style={{ color: ringColor(wellnessScore) }}>
//                     {wellnessScore}
//                   </Typography>
//                   <Typography component="span" className="ews-rlbl">
//                     Wellness
//                   </Typography>
//                 </Box>
//               </Box>
//               <Box className="ews-sc-info">
//                 <Typography component="h3">{getStatusTitle()}</Typography>
//                 <Typography component="p">{getStatusText()}</Typography>
//               </Box>
//             </Box>
//           </Box>

//           {/* twin mini rings */}
//           <Box className="ews-card ews-fu ews-d2">
//             <Box className="ews-twin-rings">
//               <Box className="ews-mini-ring-card">
//                 <Box className="ews-mini-ring">
//                   <svg viewBox="0 0 76 76">
//                     <defs>
//                       <linearGradient id="ewsBodyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                         <stop offset="0%" stopColor="#14b8a6" />
//                         <stop offset="100%" stopColor="#0d9488" />
//                       </linearGradient>
//                     </defs>
//                     <circle className="ews-mrtrk" cx="38" cy="38" r="34" />
//                     <circle
//                       className="ews-mrfil"
//                       cx="38"
//                       cy="38"
//                       r="34"
//                       stroke="url(#ewsBodyGrad)"
//                       style={{ strokeDashoffset: MINI_C - (tensionScore / 100) * MINI_C }}
//                     />
//                   </svg>
//                   <Box className="ews-mrval">
//                     <Typography component="span" className="ews-mrnum" style={{ color: ringColor(tensionScore) }}>
//                       {tensionScore}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Typography className="ews-mrlabel">Body Scan</Typography>
//               </Box>

//               <Box className="ews-mini-ring-card">
//                 <Box className="ews-mini-ring">
//                   <svg viewBox="0 0 76 76">
//                     <defs>
//                       <linearGradient id="ewsEnergyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                         <stop offset="0%" stopColor="#8b5cf6" />
//                         <stop offset="100%" stopColor="#7c3aed" />
//                       </linearGradient>
//                     </defs>
//                     <circle className="ews-mrtrk" cx="38" cy="38" r="34" />
//                     <circle
//                       className="ews-mrfil"
//                       cx="38"
//                       cy="38"
//                       r="34"
//                       stroke="url(#ewsEnergyGrad)"
//                       style={{ strokeDashoffset: MINI_C - (energyScore / 100) * MINI_C }}
//                     />
//                   </svg>
//                   <Box className="ews-mrval">
//                     <Typography component="span" className="ews-mrnum" style={{ color: ringColor(energyScore) }}>
//                       {energyScore}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Typography className="ews-mrlabel">Energy Battery</Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Box>

//         {/* tension map + energy drains (side by side on desktop) */}
//         <Box className="ews-grid-2">
//           <Box className="ews-card ews-fu ews-d3">
//             <Box className="ews-sec-h">
//               <Typography component="h3">Tension Map</Typography>
//               <Typography component="p">Where your body holds stress</Typography>
//             </Box>
//             <Box className="ews-sec-list">
//               {tensionEntries.length === 0 ? (
//                 <Typography className="ews-empty">No tension areas reported — your body feels at ease. 🌿</Typography>
//               ) : (
//                 tensionEntries.map(([part, level]) => {
//                   const { text, cls } = getLevel(level);
//                   const formatted = formatPart(part);
//                   return (
//                     <Box key={part} className={`ews-tmap-row ${getRowClass(level)}`}>
//                       <Typography component="span" className="ews-tz-icon">
//                         {bodyInfo[formatted]?.emoji || "⚡"}
//                       </Typography>
//                       <Box sx={{ flex: 1 }}>
//                         <Typography className="ews-tz-name">{formatted}</Typography>
//                         <Typography className="ews-tz-what">{bodyInfo[formatted]?.desc}</Typography>
//                       </Box>
//                       <Typography component="span" className={`ews-tz-lvl ${cls}`}>
//                         {text}
//                       </Typography>
//                     </Box>
//                   );
//                 })
//               )}
//             </Box>
//           </Box>

//           {/* energy drains */}
//           {filteredDrains.length > 0 && (
//             <Box className="ews-card ews-fu ews-d4">
//               <Box className="ews-sec-h">
//                 <Typography component="h3">Energy Drains</Typography>
//                 <Typography component="p">What's consuming your reserves</Typography>
//               </Box>
//               <Box className="ews-sec-list">
//                 {filteredDrains.map((item) => (
//                   <Box key={item.id} className="ews-drain-row">
//                     <Typography component="span" className="ews-dr-emoji">
//                       {item.icon || "⚡"}
//                     </Typography>
//                     <Box sx={{ flex: 1 }}>
//                       <Typography className="ews-dr-name">{item.label}</Typography>
//                       <Typography className="ews-dr-insight">{item.insight}</Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             </Box>
//           )}
//         </Box>

//         {/* recommended tracks */}
//         <Box className="ews-card ews-fu ews-d5">
//           <Box className="ews-th">
//             <Typography component="h3">Recommended Therapeutic Sounds</Typography>
//             <Typography component="p">Frequency-matched healing audio for your state</Typography>
//           </Box>
//           <Box className="ews-tlist">
//             {songs.map((s, i) => {
//               const emoji = getTrackEmoji(s);
//               const iconBg = getTrackIconBg(s);
//               const frequencyTag = formatTagValue(s.frequency, "Hz");
//               const durationTag = formatTagValue(s.duration, "min");
//               const inlineFrequency =
//                 s.frequency !== undefined && s.frequency !== null && s.frequency !== ""
//                   ? typeof s.frequency === "number"
//                     ? `${s.frequency} Hz`
//                     : s.frequency
//                   : null;

//               return (
//                 <Box
//                   key={i}
//                   className="ews-tc"
//                   onClick={() => handleTrackClick(s)}
//                   sx={{
//                     cursor: "pointer",
//                   }}
//                 >
//                   <Box className="ews-ti" sx={{ background: iconBg }}>
//                     {emoji}
//                   </Box>

//                   <Box className="ews-tb">
//                     <Typography className="ews-tn">
//                       {s.title}
//                       {inlineFrequency ? ` — ${inlineFrequency}` : ""}
//                     </Typography>

//                     <Typography className="ews-td">
//                       {s.subtitle1}
//                     </Typography>

//                     {s.subtitle2 && (
//                       <Typography className="ews-td">
//                         {s.subtitle2}
//                       </Typography>
//                     )}

//                     <Stack direction="row" className="ews-tags">
//                       {frequencyTag && (
//                         <Typography component="span" className="ews-tag">
//                           {frequencyTag}
//                         </Typography>
//                       )}

//                       {durationTag && (
//                         <Typography component="span" className="ews-tag">
//                           {durationTag}
//                         </Typography>
//                       )}
//                     </Stack>
//                   </Box>

//                   <IconButton
//                     className="ews-tp"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleTrackClick(s);
//                     }}
//                   >
//                     <PlayTriangle />
//                   </IconButton>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>

//         {/* start over */}
//         <Button className="ews-btn-retry ews-fu ews-d6" onClick={() => navigate("/decode-stress")}>
//           ↻ Start Over
//         </Button>

//         <Typography className="ews-note">echoShine · Wellness Assessment</Typography>
//       </Box>

//       {/* audio dialog — same visual language as the rest of the page */}
//       <Dialog
//         open={openAudioDialog}
//         onClose={() => setOpenAudioDialog(false)}
//         fullWidth
//         maxWidth="xs"
//         PaperProps={{
//           sx: {
//             borderRadius: "22px",
//             fontFamily: "'DM Sans', sans-serif",
//             overflow: "visible",
//           },
//         }}
//       >
//         <DialogContent sx={{ p: 0 }}>
//           <Box className="ews-root" sx={{ borderRadius: "22px" }}>
//             <style>{ECHO_SHINE_CSS}</style>
//             <Box sx={{ position: "relative", px: 3, pb: 3 }}>
//               <IconButton
//                 size="small"
//                 onClick={() => setOpenAudioDialog(false)}
//                 sx={{ position: "absolute", right: 8, top: 8, color: "var(--tx3)" }}
//               >
//                 ✕
//               </IconButton>

//               <Box className="ews-modal-top">
//                 <Box className="ews-modal-icon">🎵</Box>
//                 <Typography className="ews-modal-h">{selectedTrack?.title}</Typography>
//                 <Typography className="ews-modal-sub">echo Therapeutic Session</Typography>
//               </Box>

//               <audio
//                 ref={audioRef}
//                 src={audioUrl}
//                 autoPlay
//                 preload="auto"
//                 style={{ display: "none" }}
//                 onPlay={() => setIsPlaying(true)}
//                 onPause={() => setIsPlaying(false)}
//                 onSeeking={(e) => {
//                   e.target.currentTime = currentTime;
//                 }}
//                 onLoadedMetadata={(e) => setDuration(e.target.duration)}
//                 onTimeUpdate={(e) => setCurrentTime(e.target.currentTime)}
//                 onEnded={() => setIsAudioCompleted(true)}
//               />

//               {!isPlaying && !isAudioCompleted && (
//                 <Button fullWidth className="ews-play-btn" onClick={handleManualPlay}>
//                   {currentTime > 0 ? "▶ Resume" : "▶ Tap to Play"}
//                 </Button>
//               )}

//               <Box sx={{ mt: 2.5 }}>
//                 <Box className="ews-progress-time">
//                   <Typography component="span">{formatTime(currentTime)}</Typography>
//                   <Typography component="span">{formatTime(duration)}</Typography>
//                 </Box>
//                 <Box className="ews-progress-track">
//                   <Box
//                     className="ews-progress-fill"
//                     style={{ width: `${(currentTime / duration) * 100 || 0}%` }}
//                   />
//                 </Box>
//               </Box>

//               {isAudioCompleted && (
//                 <Button className="ews-complete-btn" onClick={() => setOpenAudioDialog(false)}>
//                   Complete Session
//                 </Button>
//               )}
//             </Box>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };

// export default ResultPage;
import React, { useEffect, useMemo, useRef, useState } from "react";
import { saveWellnessAssessment, getWellnessAssessments } from "../../service/wellnessAssessment";
import {
  Box,
  Typography,
  Stack,
  IconButton,
  Button,
  Dialog,
  DialogContent,
  GlobalStyles,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { drains } from "./AssessmentFlow";
import { getSmartBiometricSound } from "../../service/home";
import soundTherapyTracks from "./SmartBiometricTherapy.json";

/* ─────────────────────────────────────────────────────────────
   echoShine design tokens — same palette as the original CSS,
   just expressed as JS values consumed through the sx prop.
───────────────────────────────────────────────────────────── */
const C = {
  bg: "#f5f5fa",
  white: "#fff",
  sf: "#fff",
  sf2: "#eeeff5",
  sf3: "#e4e5ee",
  bd: "#dddde6",
  bd2: "#cbcbd8",
  teal: "#0d9488",
  tealL: "#14b8a6",
  tealBg: "rgba(13,148,136,.07)",
  tealGlow: "rgba(13,148,136,.22)",
  purple: "#7c3aed",
  purpleL: "#8b5cf6",
  purpleBg: "rgba(124,58,237,.07)",
  purpleGlow: "rgba(124,58,237,.18)",
  amber: "#d97706",
  amberBg: "rgba(217,119,6,.07)",
  red: "#dc2626",
  redBg: "rgba(220,38,38,.06)",
  green: "#16a34a",
  greenBg: "rgba(22,163,74,.07)",
  tx: "#18162a",
  tx2: "#5e5c72",
  tx3: "#908ea3",
  r: "22px",
  rs: "14px",
};

const FRAUNCES = "'Fraunces', serif";
const DMSANS = "'DM Sans', sans-serif";

// breakpoints used by the original hand-rolled CSS (860px / 1200px) —
// kept as raw media queries so the layout switches at the exact same points.
const MQ_DESKTOP = "@media (min-width:860px)";
const MQ_WIDE = "@media (min-width:1200px)";

// global font import + keyframes (fade-up entrance + gradient glow reuse)
const globalStyles = (
  <GlobalStyles
    styles={{
      "@import":
        "url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700;9..144,800&display=swap')",
      "@keyframes ewsFadeUp": {
        from: { opacity: 0, transform: "translateY(16px)" },
        to: { opacity: 1, transform: "translateY(0)" },
      },
    }}
  />
);

// reusable "fade up on mount" sx, with the same stagger delays as .ews-d1..d6
const fadeUp = (delay = 0) => ({
  opacity: 0,
  animation: "ewsFadeUp .6s ease forwards",
  animationDelay: `${delay}s`,
});

const cardSx = {
  background: C.sf,
  border: `1px solid ${C.bd}`,
  borderRadius: C.r,
  overflow: "hidden",
  boxShadow: "0 2px 12px rgba(0,0,0,.04)",
};

const bodyInfo = {
  Head: { emoji: "🧠", desc: "Tension headaches — cognitive overload, worry, anxiety" },
  Neck: { emoji: "🦴", desc: "Cervical tension — mental strain, screen fatigue, vigilance" },
  Chest: { emoji: "❤️", desc: "Chest tightness — anxiety, grief, emotional suppression" },
  Stomach: { emoji: "🫁", desc: "Gut tension — anxiety, fear, emotional processing (gut-brain axis)" },
  "Left Shoulder": { emoji: "💪", desc: "Carried burden — emotional weight, responsibility" },
  "Right Shoulder": { emoji: "💪", desc: "Carried burden — overwork, accumulated stress" },
  "Left Arm": { emoji: "🦾", desc: "Held tension — control needs, frustration" },
  "Right Arm": { emoji: "🦾", desc: "Held tension — action suppression, overuse" },
  "Left Hand": { emoji: "🤲", desc: "Grip tension — holding on, anxiety, control" },
  "Right Hand": { emoji: "🤲", desc: "Grip tension — perfectionism, repetitive strain" },
  "Lower Back": { emoji: "🔻", desc: "Foundation strain — financial stress, feeling unsupported" },
  "Left Leg": { emoji: "🦵", desc: "Restlessness — fight-or-flight activation" },
  "Right Leg": { emoji: "🦵", desc: "Restlessness — urge to run, grounding loss" },
  "Left Foot": { emoji: "🦶", desc: "Grounding loss — disconnection, instability" },
  "Right Foot": { emoji: "🦶", desc: "Grounding loss — restlessness, instability" },
};

const PROTOTYPE_TRACKS_BY_CATEGORY = {
  low: [
    { trackId: "sound-therapy-low-en-1.mp3", title: "Deep Calm — 174 Hz", subtitle1: "Grounding frequency for safety and deep relaxation", subtitle2: "Balance", frequency: "174 Hz", duration: "12 min", icon: "calm", emoji: "🌊" },
    { trackId: "sound-therapy-low-en-2.mp3", title: "Tranquil Mind — 396 Hz", subtitle1: "Liberation frequency to dissolve held tension", subtitle2: "Calm Focus", frequency: "396 Hz", duration: "15 min", icon: "calm", emoji: "🍃" },
    { trackId: "sound-therapy-low-en-3.mp3", title: "Inner Peace — 528 Hz", subtitle1: "Transformation frequency for cellular-level restoration", subtitle2: "Light Relaxation", frequency: "528 Hz", duration: "18 min", icon: "calm", emoji: "✨" },
    { trackId: "sound-therapy-low-en-4.mp3", title: "Serenity Flow — 285 Hz", subtitle1: "Cellular repair and continued relaxation", subtitle2: "Emotional Ease", frequency: "285 Hz", duration: "14 min", icon: "calm", emoji: "💧" },
  ],
  medium: [
    { trackId: "sound-therapy-medium-en-16.mp3", title: "Tension Release — 396 Hz", subtitle1: "Target stress-held tension in your body and mind", subtitle2: "Stress Reset", frequency: "396 Hz", duration: "20 min", icon: "heal", emoji: "🌸" },
    { trackId: "sound-therapy-medium-en-17.mp3", title: "Somatic Reset — 417 Hz", subtitle1: "Break stress patterns and restore energy flow", subtitle2: "Calm Recovery", frequency: "417 Hz", duration: "18 min", icon: "heal", emoji: "🔄" },
    { trackId: "sound-therapy-medium-en-18.mp3", title: "Heart Opener — 639 Hz", subtitle1: "Reconnect emotionally when drained and isolated", subtitle2: "Emotional Balance", frequency: "639 Hz", duration: "15 min", icon: "heal", emoji: "💚" },
    { trackId: "sound-therapy-medium-en-19.mp3", title: "Ground & Center — 174 Hz", subtitle1: "Lowest Solfeggio to anchor a depleted system", subtitle2: "Focused Calm", frequency: "174 Hz", duration: "22 min", icon: "heal", emoji: "🫧" },
  ],
  high: [
    { trackId: "sound-therapy-high-en-31.mp3", title: "Morning Awakening — 741 Hz", subtitle1: "Cleansing frequency to revitalize depleted energy", subtitle2: "Energy Reset", frequency: "741 Hz", duration: "10 min", icon: "energy", emoji: "☀️" },
    { trackId: "sound-therapy-high-en-32.mp3", title: "Focus Boost — 852 Hz", subtitle1: "Sharpen scattered energy into focused clarity", subtitle2: "Mental Clarity", frequency: "852 Hz", duration: "12 min", icon: "focus", emoji: "🎯" },
    { trackId: "sound-therapy-high-en-33.mp3", title: "Vitality Surge — 963 Hz", subtitle1: "Full activation for deep depletion recovery", subtitle2: "Recovery", frequency: "963 Hz", duration: "14 min", icon: "energy", emoji: "⚡" },
    { trackId: "sound-therapy-high-en-34.mp3", title: "Creative Flow — 528 Hz", subtitle1: "Reignite creative and motivational energy", subtitle2: "Inspiration", frequency: "528 Hz", duration: "16 min", icon: "energy", emoji: "🎨" },
  ],
};

const TRACK_EMOJI_MAP = {
  "Deep Calm — 174 Hz": "🌊",
  "Tranquil Mind — 396 Hz": "🍃",
  "Inner Peace — 528 Hz": "✨",
  "Serenity Flow — 285 Hz": "💧",
  "Tension Release — 396 Hz": "🌸",
  "Somatic Reset — 417 Hz": "🔄",
  "Heart Opener — 639 Hz": "💚",
  "Ground & Center — 174 Hz": "🫧",
  "Morning Awakening — 741 Hz": "☀️",
  "Focus Boost — 852 Hz": "🎯",
  "Vitality Surge — 963 Hz": "⚡",
  "Creative Flow — 528 Hz": "🎨",
  "Sleep Cradle — 174 Hz": "🌙",
  "Dream Weave — 285 Hz": "💤",
  "Night Calm — 396 Hz": "🌌",
  "Deep Rest — 432 Hz": "🛌",
};

const TRACK_ICON_BG_MAP = {
  calm: "rgba(13,148,136,.07)",
  heal: "rgba(220,38,38,.06)",
  energy: "rgba(217,119,6,.07)",
  sleep: "rgba(124,58,237,.07)",
  focus: "rgba(37,99,235,.07)",
};

const TRACK_ICON_CATEGORY_MAP = {
  musicnote: "calm",
  centerfocusstrong: "focus",
  volumedown: "calm",
  restore: "calm",
  landscape: "heal",
  selfimprovement: "focus",
  terrain: "calm",
  psychology: "heal",
  air: "calm",
  waves: "sleep",
  pausecircle: "sleep",
  scale: "focus",
  adjust: "focus",
  favoriteborder: "heal",
  sync: "energy",
  visibility: "heal",
  shield: "calm",
};

const TRACK_ICON_EMOJI_MAP = {
  musicnote: "🎵",
  centerfocusstrong: "🧘",
  volumedown: "🔈",
  restore: "🌿",
  landscape: "🌄",
  selfimprovement: "✨",
  terrain: "🪨",
  psychology: "🧠",
  air: "💨",
  waves: "🌊",
  pausecircle: "⏸️",
  scale: "⚖️",
  adjust: "🎚️",
  favoriteborder: "💛",
  sync: "🔄",
  visibility: "👁️",
  shield: "🛡️",
  default: "🎵",
};

const normalizeTrackTitle = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[\s—-]+/g, " ")
    .replace(/\s+\d+\s*(hz|hertz)?$/i, "")
    .replace(/\s+/g, " ");

const getTrackEmoji = (song = {}) => {
  if (song?.emoji) return song.emoji;

  const directMatch = song?.title && TRACK_EMOJI_MAP[song.title];
  if (directMatch) return directMatch;

  const normalizedTitle = normalizeTrackTitle(song?.title);
  const matchedTitle = Object.entries(TRACK_EMOJI_MAP).find(([title]) => normalizeTrackTitle(title) === normalizedTitle);
  if (matchedTitle) return matchedTitle[1];

  const iconKey = String(song?.icon || "").toLowerCase();
  return TRACK_ICON_EMOJI_MAP[iconKey] || TRACK_ICON_EMOJI_MAP.default;
};

const getTrackIconBg = (song = {}) => {
  if (song?.iconBg) return song.iconBg;

  const iconKey = String(song?.icon || "").toLowerCase();
  const category = TRACK_ICON_CATEGORY_MAP[iconKey];
  return TRACK_ICON_BG_MAP[category] || "rgba(13,148,136,.07)";
};

const formatTagValue = (value, unitSuffix) => {
  if (value === undefined || value === null || value === "") return null;
  if (typeof value === "number") return `${value} ${unitSuffix}`;
  return String(value);
};

const PlayTriangle = ({ fill = "#0d9488" }) => (
  <svg width="16" height="16" viewBox="0 0 24 24">
    <polygon className="ews-ptri" points="5,3 19,12 5,21" fill={fill} />
  </svg>
);

const ResultPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [audioUrl, setAudioUrl] = useState("");
  const [openAudioDialog, setOpenAudioDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isAudioCompleted, setIsAudioCompleted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hoveredTrackIndex, setHoveredTrackIndex] = useState(null);
  const [trackDurations, setTrackDurations] = useState({});
  const handleManualPlay = () => {
    if (!audioRef.current) return;
    audioRef.current.play().catch((err) => console.log("Manual play failed", err));
  };

  const { bodyData = {}, battery = 50, selectedDrains = [], heartRate = null } = state || {};

  const audioRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const formatPart = (part) => {
    if (part === "lowBack") return "Lower Back";
    return part.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
  };

  const tensionEntries = Object.entries(bodyData).filter(([, v]) => v > 0);
  const filteredDrains = drains.filter((d) => selectedDrains.includes(d.id));

  const totalPossibleStress = 15;
  const currentStress = tensionEntries.reduce((sum, [, level]) => sum + level, 0);
  const stressRatio = currentStress / totalPossibleStress;
  const tensionScore = Math.round(Math.max(5, Math.min(95, 100 - stressRatio * 120)));

  const drainPenalty = filteredDrains.length * 4;
  const energyScore = Math.max(5, Math.min(95, battery - drainPenalty));
  const wellnessScore = Math.round(tensionScore * 0.5 + energyScore * 0.5);

  const getLevel = (level) => {
    if (level === 1) return { text: "MILD", cls: "l1" };
    if (level === 2) return { text: "MODERATE", cls: "l2" };
    return { text: "INTENSE", cls: "l3" };
  };
  const isHighLevel = (level) => level === 3;
  const isMedLevel = (level) => level === 2;

  const getStatusTitle = () => {
    if (wellnessScore >= 70) return "Well Balanced";
    if (wellnessScore >= 45) return "Moderate Stress Load";
    return "Elevated Stress Response";
  };

  const getStatusText = () => {
    if (wellnessScore >= 70)
      return "Your body and energy are both in good shape. Minimal tension and adequate reserves suggest a well-managed stress response. Maintenance therapy can help sustain this.";
    if (wellnessScore >= 45)
      return "Your body is holding tension and/or your energy reserves are under pressure. Targeted sound therapy can address both the physical patterns and mental depletion.";
    return "Significant body tension combined with depleted energy indicates your system is under considerable strain. Prioritize therapeutic recovery — your body and mind are both asking for care.";
  };

  const ringColor = (score) => (score >= 70 ? C.teal : score >= 45 ? C.amber : C.red);

  const getCategory = (wellnessScore) => {
    if (wellnessScore >= 70) return "low";
    if (wellnessScore >= 45) return "medium";
    return "high";
  };

  const getRandomSongs = (arr, count = 3) => {
    if (!arr || arr.length === 0) return [];
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled.slice(0, Math.min(count, shuffled.length));
  };

  const category = getCategory(wellnessScore);

  const songs = useMemo(() => {
    const pool = PROTOTYPE_TRACKS_BY_CATEGORY[category] || PROTOTYPE_TRACKS_BY_CATEGORY.low;
    const selectedPrototypeSongs = getRandomSongs(pool, 3);
    const selectedBaseSongs = getRandomSongs(soundTherapyTracks[category] || [], 3);

    const mappedSongs = selectedPrototypeSongs.map((song, index) => {
      const baseSong = selectedBaseSongs[index] || {};
      return {
        ...baseSong,
        ...song,
        trackId: baseSong.trackId || song.trackId,
        subtitle1: song.subtitle1,
        subtitle2: song.subtitle2,
        frequency: song.frequency,
        duration: song.duration,
        icon: song.icon,
        emoji: song.emoji,
      };
    });

    if (user?.account_id !== 5) return mappedSongs;
    return mappedSongs.map((song) => ({ ...song, trackId: `consero-${song.trackId}` }));
  }, [category, user?.account_id]);

  const payload = {
    user_id: user?.id,
    wellness_score: wellnessScore,
    tension_score: tensionScore,
    energy_score: energyScore,
    battery_input: battery,
    wellness_status: getStatusTitle(),
    tension_map: tensionEntries.map(([part, level]) => ({
      part: formatPart(part),
      raw_key: part,
      level: level,
      label: getLevel(level).text,
    })),
    energy_drains: filteredDrains.map((item) => ({
      id: item.id,
      label: item.label,
      insight: item.insight,
    })),
    recommended_tracks: songs.map((song) => ({
      track_id: song.trackId,
      title: song.title,
      subtitle: song.subtitle1,
    })),
  };

  useEffect(() => {
    if (!user?.id) return;

    const saveAssessment = async () => {
      try {
        console.log("Sending Payload", payload);
        const response = await saveWellnessAssessment(payload);
        console.log(response);
      } catch (err) {
        console.error(err.response?.data || err);
      }
    };

    saveAssessment();
  }, []);

// Preload real durations for all recommended tracks in the background,
// so the card shows the accurate time before the user ever opens the dialog.
useEffect(() => {
  if (!songs || songs.length === 0) return;
  let cancelled = false;

  const preloadDurations = async () => {
    for (const song of songs) {
      try {
        const data = await getSmartBiometricSound(song.trackId);
        if (cancelled || !data?.track_url) continue;

        // preload="metadata" only fetches the file header (duration, etc.),
        // not the full audio — cheap and doesn't play anything.
        const probe = new Audio();
        probe.preload = "metadata";
        probe.src = data.track_url;

        probe.addEventListener("loadedmetadata", () => {
          if (cancelled) return;
          setTrackDurations((prev) => ({
            ...prev,
            [song.trackId]: probe.duration,
          }));
        });
      } catch (err) {
        console.error("Failed to preload duration for", song.trackId, err);
      }
    }
  };

  preloadDurations();

  return () => {
    cancelled = true;
  };
}, [songs]);

  const formatTime = (seconds = 0) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  const handleTrackClick = async (track) => {
    try {
      setLoading(true);
      setSelectedTrack(track);
      setIsAudioCompleted(false);
      setIsPlaying(false);
      setCurrentTime(0);
      setDuration(0);

      const data = await getSmartBiometricSound(track.trackId);

      setAudioUrl(data.track_url);
      setOpenAudioDialog(true);
    } catch (err) {
      console.error("Failed to load therapeutic sound:", err);
    } finally {
      setLoading(false);
    }
  };

  // ring geometry
  const RING_C = 2 * Math.PI * 45; // combined ring r=45 -> 282.7
  const MINI_C = 2 * Math.PI * 34; // mini ring r=34 -> 213.6

  return (
    <Box
      sx={{
        fontFamily: DMSANS,
        background: C.bg,
        color: C.tx,
        width: "100%",
        minHeight: "100%",
        position: "relative",
      }}
    >
      {globalStyles}

      {/* ambient background gradients */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          zIndex: 0,
          background: `radial-gradient(ellipse at 15% 5%, rgba(13,148,136,.05) 0%, transparent 50%),
            radial-gradient(ellipse at 85% 95%, rgba(124,58,237,.04) 0%, transparent 50%)`,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          padding: "20px 16px 48px",
          [MQ_DESKTOP]: { maxWidth: 920, padding: "36px 32px 64px" },
          [MQ_WIDE]: { maxWidth: 1080 },
        }}
      >
        {/* brand header — fixed size, no desktop scaling (matches previous UI) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 2px 2px",
            position: "relative",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{
                width: 42,
                height: 42,
                background: `linear-gradient(135deg, ${C.teal}, ${C.purple})`,
                borderRadius: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
                flexShrink: 0,
                boxShadow: `0 4px 16px ${C.tealGlow}, 0 4px 16px ${C.purpleGlow}`,
              }}
            >
              🌟
            </Box>
            <Box>
              <Typography
                component="h1"
                sx={{
                  fontFamily: FRAUNCES,
                  fontSize: 20,
                  fontWeight: 700,
                  lineHeight: 1.2,
                  m: 0,
                  backgroundImage: `linear-gradient(135deg, ${C.teal}, ${C.purple})`,
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                echoShine
              </Typography>
              <Typography
                component="p"
                sx={{
                  fontSize: 11,
                  color: C.tx2,
                  letterSpacing: "0.3px",
                  mt: "1px",
                  mb: 0,
                }}
              >
                Student Wellness Assessment
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={() => navigate("/echo-sounds")}
            sx={{
              background: "#F0F5FF !important",
              width: 35,
              height: 35,
              color: "#0B2D6B !important",
              flexShrink: 0,
              alignSelf: "center",
              "&:hover": { background: "#E0EBFF !important" },
            }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ textAlign: "center", padding: "10px 0", ...fadeUp(0.1) }}>
          <Typography
            component="h2"
            sx={{
              fontFamily: FRAUNCES,
              fontWeight: 700,
              m: 0,
              mb: "4px",
              fontSize: 24,
              [MQ_DESKTOP]: { fontSize: 30 },
            }}
          >
            Your Wellness Profile
          </Typography>
          <Typography
            component="p"
            sx={{ fontSize: 13, color: C.tx2, m: 0, [MQ_DESKTOP]: { fontSize: 14 } }}
          >
            Body tension + energy drain analysis
          </Typography>
        </Box>

        {/* combined score + twin rings (side by side on desktop) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            [MQ_DESKTOP]: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", alignItems: "stretch" },
          }}
        >
          <Box sx={{ ...cardSx, ...fadeUp(0.1) }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "22px",
                padding: "26px 22px",
                [MQ_DESKTOP]: { padding: "30px 26px" },
              }}
            >
              <Box sx={{ position: "relative", width: 105, height: 105, flexShrink: 0 }}>
                <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", transform: "rotate(-90deg)" }}>
                  <defs>
                    <linearGradient id="ewsRingGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#14b8a6" />
                      <stop offset="100%" stopColor="#8b5cf6" />
                    </linearGradient>
                  </defs>
                  <circle fill="none" stroke={C.sf2} strokeWidth="7" cx="50" cy="50" r="45" />
                  <circle
                    fill="none"
                    strokeWidth="7"
                    strokeLinecap="round"
                    strokeDasharray="282.7"
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="url(#ewsRingGrad)"
                    style={{
                      strokeDashoffset: RING_C - (wellnessScore / 100) * RING_C,
                      transition: "stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)",
                    }}
                  />
                </svg>
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    component="span"
                    sx={{ fontFamily: FRAUNCES, fontSize: 34, fontWeight: 800, lineHeight: 1, display: "block", color: ringColor(wellnessScore) }}
                  >
                    {wellnessScore}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "1px", color: C.tx3, mt: "2px", display: "block" }}
                  >
                    Wellness
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography component="h3" sx={{ fontSize: 15, fontWeight: 700, m: 0, mb: "5px" }}>
                  {getStatusTitle()}
                </Typography>
                <Typography component="p" sx={{ fontSize: "12.5px", color: C.tx2, lineHeight: 1.6, m: 0 }}>
                  {getStatusText()}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* twin mini rings */}
          <Box sx={{ ...cardSx, ...fadeUp(0.2) }}>
            <Box sx={{ display: "flex", gap: "12px", padding: "22px" }}>
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", padding: "20px 12px", borderRadius: "16px", background: C.sf2 }}>
                <Box sx={{ position: "relative", width: 80, height: 80 }}>
                  <svg viewBox="0 0 76 76" style={{ width: "100%", height: "100%", transform: "rotate(-90deg)" }}>
                    <defs>
                      <linearGradient id="ewsBodyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#14b8a6" />
                        <stop offset="100%" stopColor="#0d9488" />
                      </linearGradient>
                    </defs>
                    <circle fill="none" stroke={C.sf3} strokeWidth="6" cx="38" cy="38" r="34" />
                    <circle
                      fill="none"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeDasharray="213.6"
                      cx="38"
                      cy="38"
                      r="34"
                      stroke="url(#ewsBodyGrad)"
                      style={{
                        strokeDashoffset: MINI_C - (tensionScore / 100) * MINI_C,
                        transition: "stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)",
                      }}
                    />
                  </svg>
                  <Box sx={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Typography component="span" sx={{ fontFamily: FRAUNCES, fontSize: 24, fontWeight: 800, lineHeight: 1, display: "block", color: ringColor(tensionScore) }}>
                      {tensionScore}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.tx3, textTransform: "uppercase", letterSpacing: "0.6px", textAlign: "center" }}>
                  Body Scan
                </Typography>
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", padding: "20px 12px", borderRadius: "16px", background: C.sf2 }}>
                <Box sx={{ position: "relative", width: 80, height: 80 }}>
                  <svg viewBox="0 0 76 76" style={{ width: "100%", height: "100%", transform: "rotate(-90deg)" }}>
                    <defs>
                      <linearGradient id="ewsEnergyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#8b5cf6" />
                        <stop offset="100%" stopColor="#7c3aed" />
                      </linearGradient>
                    </defs>
                    <circle fill="none" stroke={C.sf3} strokeWidth="6" cx="38" cy="38" r="34" />
                    <circle
                      fill="none"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeDasharray="213.6"
                      cx="38"
                      cy="38"
                      r="34"
                      stroke="url(#ewsEnergyGrad)"
                      style={{
                        strokeDashoffset: MINI_C - (energyScore / 100) * MINI_C,
                        transition: "stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)",
                      }}
                    />
                  </svg>
                  <Box sx={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Typography component="span" sx={{ fontFamily: FRAUNCES, fontSize: 24, fontWeight: 800, lineHeight: 1, display: "block", color: ringColor(energyScore) }}>
                      {energyScore}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.tx3, textTransform: "uppercase", letterSpacing: "0.6px", textAlign: "center" }}>
                  Energy Battery
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* tension map + energy drains (side by side on desktop) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            [MQ_DESKTOP]: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", alignItems: "stretch" },
          }}
        >
          <Box sx={{ ...cardSx, ...fadeUp(0.35) }}>
            <Box sx={{ padding: "20px 22px 6px" }}>
              <Typography component="h3" sx={{ fontFamily: FRAUNCES, fontSize: 16, fontWeight: 600, m: 0 }}>
                Tension Map
              </Typography>
              <Typography component="p" sx={{ fontSize: 12, color: C.tx2, m: "2px 0 0" }}>
                Where your body holds stress
              </Typography>
            </Box>
            <Box sx={{ padding: "12px 22px 22px", display: "flex", flexDirection: "column", gap: "10px" }}>
              {tensionEntries.length === 0 ? (
                <Typography sx={{ padding: "12px 0", fontSize: 13, color: C.tx3 }}>
                  No tension areas reported — your body feels at ease. 🌿
                </Typography>
              ) : (
                tensionEntries.map(([part, level]) => {
                  const { text } = getLevel(level);
                  const formatted = formatPart(part);
                  const high = isHighLevel(level);
                  const med = isMedLevel(level);
                  const lvlSx = high
                    ? { background: "rgba(124,58,237,.15)", color: C.purple }
                    : { background: med ? "rgba(13,148,136,.2)" : "rgba(13,148,136,.12)", color: C.teal };
                  return (
                    <Box
                      key={part}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "12px 14px",
                        borderRadius: "12px",
                        background: high ? C.purpleBg : med ? C.tealBg : C.sf2,
                        borderLeft: high ? `3px solid ${C.purple}` : med ? `3px solid ${C.teal}` : "none",
                      }}
                    >
                      <Typography component="span" sx={{ fontSize: 20, width: 28, textAlign: "center", flexShrink: 0 }}>
                        {bodyInfo[formatted]?.emoji || "⚡"}
                      </Typography>
                      <Box sx={{ flex: 1 }}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.tx }}>{formatted}</Typography>
                        <Typography sx={{ fontSize: 11, color: C.tx2, lineHeight: 1.4, mt: "2px" }}>
                          {bodyInfo[formatted]?.desc}
                        </Typography>
                      </Box>
                      <Typography
                        component="span"
                        sx={{
                          fontSize: 10,
                          fontWeight: 700,
                          padding: "4px 10px",
                          borderRadius: "8px",
                          textTransform: "uppercase",
                          letterSpacing: "0.4px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          ...lvlSx,
                        }}
                      >
                        {text}
                      </Typography>
                    </Box>
                  );
                })
              )}
            </Box>
          </Box>

          {/* energy drains */}
          {filteredDrains.length > 0 && (
            <Box sx={{ ...cardSx, ...fadeUp(0.5) }}>
              <Box sx={{ padding: "20px 22px 6px" }}>
                <Typography component="h3" sx={{ fontFamily: FRAUNCES, fontSize: 16, fontWeight: 600, m: 0 }}>
                  Energy Drains
                </Typography>
                <Typography component="p" sx={{ fontSize: 12, color: C.tx2, m: "2px 0 0" }}>
                  What's consuming your reserves
                </Typography>
              </Box>
              <Box sx={{ padding: "12px 22px 22px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {filteredDrains.map((item) => (
                  <Box
                    key={item.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "14px 16px",
                      borderRadius: "12px",
                      background: C.sf2,
                      borderLeft: `3px solid ${C.amber}`,
                    }}
                  >
                    <Typography component="span" sx={{ fontSize: 20, width: 28, textAlign: "center", flexShrink: 0 }}>
                      {item.icon || "⚡"}
                    </Typography>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{item.label}</Typography>
                      <Typography sx={{ fontSize: 11, color: C.tx2, lineHeight: 1.4, mt: "2px" }}>{item.insight}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Box>

        {/* recommended tracks */}
        <Box sx={{ ...cardSx, ...fadeUp(0.65) }}>
          <Box sx={{ padding: "22px 22px 0" }}>
            <Typography component="h3" sx={{ fontFamily: FRAUNCES, fontSize: 16, fontWeight: 600, m: 0, mb: "4px" }}>
              Recommended Therapeutic Sounds
            </Typography>
            <Typography component="p" sx={{ fontSize: 12, color: C.tx2, m: 0 }}>
              Frequency-matched healing audio for your state
            </Typography>
          </Box>
          <Box
            sx={{
              padding: "16px 22px 22px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            {songs.map((s, i) => {
              const emoji = getTrackEmoji(s);
              const iconBg = getTrackIconBg(s);
              const realDuration = trackDurations[s.trackId];
              const frequencyTag = formatTagValue(s.frequency, "Hz");
              // const durationTag = formatTagValue(s.duration, "min");
              const durationTag = realDuration
                ? formatTime(realDuration)          // e.g. "12:34" — matches the popup's format
                : formatTagValue(s.duration, "min"); // e.g. "12 min" — placeholder until played
              const hovered = hoveredTrackIndex === i;

              return (
                <Box
                  key={i}
                  onClick={() => handleTrackClick(s)}
                  onMouseEnter={() => setHoveredTrackIndex(i)}
                  onMouseLeave={() => setHoveredTrackIndex((prev) => (prev === i ? null : prev))}
                  sx={{
                    width: "100%",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    padding: "16px",
                    background: hovered ? C.sf : C.sf2,
                    border: `1.5px solid ${hovered ? C.teal : C.bd}`,
                    borderRadius: C.rs,
                    cursor: "pointer",
                    transition: ".25s",
                    transform: hovered ? "translateY(-2px)" : "none",
                    boxShadow: hovered ? "0 8px 24px rgba(13,148,136,.12)" : "none",
                  }}
                >
                  {/* Icon — kept compact (52px) so the title has room to sit
                      on one line; a bigger icon here is what was pushing
                      "Serenity Flow — 285 Hz" onto two lines on mobile. */}
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 24,
                      flexShrink: 0,
                      background: iconBg,
                    }}
                  >
                    {emoji}
                  </Box>

                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    {/* NOTE: track titles already include the frequency
                        (e.g. "Serenity Flow — 285 Hz"), so it must NOT be
                        appended again here — that was the source of the
                        "285 Hz — 285 Hz" duplication bug. */}
                    <Typography sx={{ fontSize: 14, fontWeight: 700, mb: "3px", color: C.tx }}>
                      {s.title}
                    </Typography>

                    <Typography sx={{ fontSize: "11.5px", color: C.tx2, lineHeight: 1.4, mb: "8px" }}>
                      {s.subtitle1}
                    </Typography>

                    {s.subtitle2 && (
                      <Typography sx={{ fontSize: "11.5px", color: C.tx2, lineHeight: 1.4, mb: "8px" }}>
                        {s.subtitle2}
                      </Typography>
                    )}

                    <Stack direction="row" sx={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      {frequencyTag && (
                        <Typography
                          component="span"
                          sx={{
                            fontSize: 10,
                            fontWeight: 700,
                            padding: "3px 9px",
                            borderRadius: "20px",
                            background: C.tealBg,
                            color: C.teal,
                            letterSpacing: "0.3px",
                            whiteSpace: "nowrap",
                            display: "inline-block",
                          }}
                        >
                          {frequencyTag}
                        </Typography>
                      )}

                      {durationTag && (
                        <Typography
                          component="span"
                          sx={{
                            fontSize: 10,
                            fontWeight: 700,
                            padding: "3px 9px",
                            borderRadius: "20px",
                            background: C.tealBg,
                            color: C.teal,
                            letterSpacing: "0.3px",
                            whiteSpace: "nowrap",
                            display: "inline-block",
                          }}
                        >
                          {durationTag}
                        </Typography>
                      )}
                    </Stack>
                  </Box>

                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTrackClick(s);
                    }}
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: "50%",
                      background: hovered
                        ? `linear-gradient(135deg, ${C.teal}, ${C.purple})`
                        : `linear-gradient(135deg, ${C.tealBg}, ${C.purpleBg})`,
                      boxShadow: hovered ? `0 0 14px ${C.tealGlow}` : "none",
                      flexShrink: 0,
                      transition: ".25s",
                    }}
                  >
                    <PlayTriangle fill={hovered ? "#fff" : "#0d9488"} />
                  </IconButton>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* start over */}
        <Button
          onClick={() => navigate("/decode-stress")}
          sx={{
            ...fadeUp(0.8),
            background: C.white,
            color: C.teal,
            border: `1.5px solid ${C.teal}`,
            padding: "16px",
            borderRadius: C.rs,
            width: "100%",
            fontFamily: DMSANS,
            fontSize: 14,
            fontWeight: 600,
            textTransform: "none",
            boxShadow: `0 2px 8px ${C.tealGlow}`,
            "&:hover": { background: C.tealBg },
            [MQ_DESKTOP]: { maxWidth: 280, margin: "0 auto" },
          }}
        >
          ↻ Start Over
        </Button>

        <Typography sx={{ fontSize: 10, color: C.tx3, textAlign: "center", lineHeight: 1.6, pt: "4px" }}>
          echoShine · Wellness Assessment
        </Typography>
      </Box>

      {/* audio dialog — same visual language as the rest of the page */}
      <Dialog
        open={openAudioDialog}
        onClose={() => setOpenAudioDialog(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: "22px",
            fontFamily: DMSANS,
            overflow: "visible",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ borderRadius: "22px", background: C.bg }}>
            <Box sx={{ position: "relative", px: 3, pb: 3 }}>
              <IconButton
                size="small"
                onClick={() => setOpenAudioDialog(false)}
                sx={{ position: "absolute", right: 8, top: 8, color: C.tx3 }}
              >
                ✕
              </IconButton>

              <Box sx={{ padding: "28px 24px 4px", textAlign: "center" }}>
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    margin: "0 auto 14px",
                    background: `linear-gradient(135deg, ${C.teal}, ${C.purple})`,
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 26,
                    boxShadow: `0 8px 24px ${C.tealGlow}, 0 8px 24px ${C.purpleGlow}`,
                  }}
                >
                  🎵
                </Box>
                <Typography sx={{ fontFamily: FRAUNCES, fontSize: 19, fontWeight: 800, color: C.tx, mb: "2px" }}>
                  {selectedTrack?.title}
                </Typography>
                <Typography sx={{ fontSize: "12.5px", color: C.tx2 }}>echo Therapeutic Session</Typography>
              </Box>

              <audio
                ref={audioRef}
                src={audioUrl}
                autoPlay
                preload="auto"
                style={{ display: "none" }}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onSeeking={(e) => {
                  e.target.currentTime = currentTime;
                }}
                onLoadedMetadata={(e) => {
                  const realDuration = e.target.duration;
                  setDuration(realDuration);
                  if (selectedTrack?.trackId) {
                    setTrackDurations((prev) => ({
                      ...prev,
                      [selectedTrack.trackId]: realDuration,
                    }));
                  }
                }}
                onTimeUpdate={(e) => setCurrentTime(e.target.currentTime)}
                onEnded={() => setIsAudioCompleted(true)}
              />

              {!isPlaying && !isAudioCompleted && (
                <Button
                  fullWidth
                  onClick={handleManualPlay}
                  sx={{
                    mt: 2,
                    padding: "14px",
                    borderRadius: C.rs,
                    border: "none",
                    fontFamily: DMSANS,
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#fff",
                    textTransform: "none",
                    background: "linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6)",
                  }}
                >
                  {currentTime > 0 ? "▶ Resume" : "▶ Tap to Play"}
                </Button>
              )}

              <Box sx={{ mt: 2.5 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: "6px", fontSize: 11, color: C.tx2 }}>
                  <Typography component="span" sx={{ fontSize: 11, color: C.tx2 }}>
                    {formatTime(currentTime)}
                  </Typography>
                  <Typography component="span" sx={{ fontSize: 11, color: C.tx2 }}>
                    {formatTime(duration)}
                  </Typography>
                </Box>
                <Box sx={{ height: 8, borderRadius: "4px", background: C.sf3, overflow: "hidden" }}>
                  <Box
                    sx={{
                      height: "100%",
                      background: "linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6)",
                      transition: "width .25s linear",
                      width: `${(currentTime / duration) * 100 || 0}%`,
                    }}
                  />
                </Box>
              </Box>

              {isAudioCompleted && (
                <Button
                  onClick={() => setOpenAudioDialog(false)}
                  sx={{
                    mt: 2.5,
                    padding: "12px 22px",
                    borderRadius: C.rs,
                    border: "none",
                    fontFamily: DMSANS,
                    fontSize: "13.5px",
                    fontWeight: 600,
                    color: "#fff",
                    textTransform: "none",
                    background: "linear-gradient(135deg,#22c55e,#14b8a6,#8b5cf6)",
                    display: "block",
                    ml: "auto",
                    mr: "auto",
                  }}
                >
                  Complete Session
                </Button>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ResultPage;

